{
  "about.blocks": "Server moderati",
  "about.contact": "Contatti:",
  "about.default_locale": "Predefinito",
  "about.disclaimer": "Mastodon è un software libero, open-source e un marchio di Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Motivo non disponibile",
  "about.domain_blocks.preamble": "Mastodon, generalmente, ti consente di visualizzare i contenuti e interagire con gli utenti da qualsiasi altro server nel fediverso. Queste sono le eccezioni che sono state fatte su questo particolare server.",
  "about.domain_blocks.silenced.explanation": "Generalmente non vedrai i profili e i contenuti di questo server, a meno che tu non lo cerchi esplicitamente o che tu scelga di seguirlo.",
  "about.domain_blocks.silenced.title": "Limitato",
  "about.domain_blocks.suspended.explanation": "Nessun dato proveniente da questo server verrà elaborato, conservato o scambiato, rendendo impossibile qualsiasi interazione o comunicazione con gli utenti da questo server.",
  "about.domain_blocks.suspended.title": "Sospeso",
  "about.language_label": "Lingua",
  "about.not_available": "Queste informazioni non sono state rese disponibili su questo server.",
  "about.powered_by": "Social media decentralizzato basato su {mastodon}",
  "about.rules": "Regole del server",
  "account.account_note_header": "Note personali",
  "account.activity": "Attività",
  "account.add_note": "Aggiungi una nota personale",
  "account.add_or_remove_from_list": "Aggiungi o Rimuovi dalle liste",
  "account.badges.admin": "Amministratore/trice",
  "account.badges.blocked": "Bloccato",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "Dominio bloccato",
  "account.badges.group": "Gruppo",
  "account.badges.muted": "Silenziato",
  "account.badges.muted_until": "Silenziato fino al {until}",
  "account.block": "Blocca @{name}",
  "account.block_domain": "Blocca dominio {domain}",
  "account.block_short": "Blocca",
  "account.blocked": "Bloccato",
  "account.cancel_follow_request": "Annulla la richiesta di seguire",
  "account.copy": "Copia il collegamento al profilo",
  "account.direct": "Menziona privatamente @{name}",
  "account.disable_notifications": "Smetti di avvisarmi quando @{name} pubblica un post",
  "account.edit_note": "Modifica la nota personale",
  "account.edit_profile": "Modifica profilo",
  "account.edit_profile_short": "Modifica",
  "account.enable_notifications": "Avvisami quando @{name} pubblica un post",
  "account.endorse": "In evidenza sul profilo",
  "account.familiar_followers_many": "Seguito da {name1}, {name2}, e {othersCount, plural, one {un altro che conosci} other {altri # che conosci}}",
  "account.familiar_followers_one": "Seguito da {name1}",
  "account.familiar_followers_two": "Seguito da {name1} e {name2}",
  "account.featured": "In evidenza",
  "account.featured.accounts": "Profili",
  "account.featured.collections": "Collezioni",
  "account.featured.new_collection": "Nuova collezione",
  "account.field_overflow": "Mostra il contenuto completo",
  "account.filters.all": "Tutte le attività",
  "account.filters.boosts_toggle": "Mostra le condivisioni",
  "account.filters.posts_boosts": "Post e condivisioni",
  "account.filters.posts_only": "Post",
  "account.filters.posts_replies": "Post e risposte",
  "account.filters.replies_toggle": "Mostra le risposte",
  "account.follow": "Segui",
  "account.follow_back": "Segui a tua volta",
  "account.follow_back_short": "Segui a tua volta",
  "account.follow_request": "Richiedi di seguire",
  "account.follow_request_cancel": "Annulla la richiesta",
  "account.follow_request_cancel_short": "Annulla",
  "account.follow_request_short": "Richiesta",
  "account.followers": "Follower",
  "account.followers.empty": "Ancora nessuno segue questo utente.",
  "account.followers_counter": "{count, plural, one {{counter} follower} other {{counter} follower}}",
  "account.followers_you_know_counter": "{counter} che conosci",
  "account.following": "Seguiti",
  "account.following_counter": "{count, plural, one {{counter} segui} other {{counter} seguiti}}",
  "account.follows.empty": "Questo utente non segue ancora nessuno.",
  "account.follows_you": "Ti segue",
  "account.go_to_profile": "Vai al profilo",
  "account.hame.invalid_handle": "Nome univoco non disponibile",
  "account.hide_reblogs": "Nascondi condivisioni da @{name}",
  "account.in_memoriam": "In memoria.",
  "account.join_modal.day": "Giorno",
  "account.join_modal.me": "Ti sei iscritto/a su {server} il",
  "account.join_modal.me_anniversary": "Buon Fediversario! Ti sei iscritto/a su {server} il",
  "account.join_modal.me_today": "È il tuo primo giorno su {server}!",
  "account.join_modal.other": "{name} si è iscritto/a su {server} il",
  "account.join_modal.other_today": "È il primo giorno di {name} su {server}!",
  "account.join_modal.share.celebrate": "Condividi un post celebrativo",
  "account.join_modal.share.intro": "Condividi un post introduttivo",
  "account.join_modal.share.welcome": "Condividi un post di benvenuto",
  "account.join_modal.years": "{number, plural, one {anno} other {anni}}",
  "account.joined_short": "Account iscritto",
  "account.languages": "Cambia le lingue dei post da ricevere",
  "account.last_active": "Ultima attività",
  "account.link_verified_on": "La proprietà di questo link è stata controllata il {date}",
  "account.locked_info": "Lo stato della privacy di questo profilo è impostato a bloccato. Il proprietario revisiona manualmente chi può seguirlo.",
  "account.media": "Media",
  "account.mention": "Menziona @{name}",
  "account.menu.add_to_collection": "Aggiungi alla collezione…",
  "account.menu.add_to_list": "Aggiungi alla lista…",
  "account.menu.block": "Blocca l'account",
  "account.menu.block_domain": "Blocca {domain}",
  "account.menu.copied": "Collegamento dell'account copiato negli appunti",
  "account.menu.copy": "Copia il сollegamento",
  "account.menu.direct": "Menziona privatamente",
  "account.menu.hide_reblogs": "Nascondi le condivisioni nella timeline",
  "account.menu.mention": "Menziona",
  "account.menu.mute": "Silenzia l'account",
  "account.menu.note.description": "Visibile solo a te",
  "account.menu.open_original_page": "Visualizza su {domain}",
  "account.menu.open_original_page_no_domain": "Visualizza sul server originale",
  "account.menu.remove_follower": "Rimuovi il follower",
  "account.menu.report": "Segnala l'account",
  "account.menu.share": "Condividi…",
  "account.menu.show_reblogs": "Mostra le condivisioni nella timeline",
  "account.menu.unblock": "Sblocca l'account",
  "account.menu.unblock_domain": "Sblocca {domain}",
  "account.menu.unmute": "Riattiva l'account",
  "account.moved_to": "{name} ha indicato che il suo nuovo profilo è ora:",
  "account.mute": "Silenzia @{name}",
  "account.mute_notifications_short": "Silenzia notifiche",
  "account.mute_short": "Silenzia",
  "account.muted": "Mutato",
  "account.mutual": "Vi seguite a vicenda",
  "account.name.copy": "Copia il nome univoco",
  "account.name.help.domain": "{domain} è il server che ospita il profilo e i post dell'utente.",
  "account.name.help.domain_self": "{domain} è il tuo server che ospita il tuo profilo e i post.",
  "account.name.help.footer": "Così come è possibile inviare email a persone che utilizzano diversi provider di posta elettronica, è altrettanto possibile interagire con persone su altri server Mastodon e con chiunque su altre app del fediverso.",
  "account.name.help.header": "Un nome univoco è come un indirizzo email",
  "account.name.help.invalid_explanation": "Questo può accadere quando un utente cambia il nome utente ed è generalmente temporaneo. Se il problema persiste, potrebbe essere dovuto a un server non disponibile o ad una configurazione errata dell'account.",
  "account.name.help.invalid_header": "Il nome univoco di questo utente è in fase di aggiornamento",
  "account.name.help.username": "{username} è il nome utente di questo account sul suo server. Qualcuno su un altro server potrebbe avere lo stesso nome utente.",
  "account.name.help.username_self": "{username} è il tuo nome utente su questo server. Qualcuno su un altro server potrebbe avere lo stesso nome utente.",
  "account.name_info": "Cosa significa questo?",
  "account.no_bio": "Nessuna descrizione fornita.",
  "account.node_modal.callout": "Le note personali sono visibili solo per te.",
  "account.node_modal.edit_title": "Modifica la nota personale",
  "account.node_modal.error_unknown": "Impossibile salvare la nota",
  "account.node_modal.field_label": "Nota personale",
  "account.node_modal.save": "Salva",
  "account.node_modal.title": "Aggiungi una nota personale",
  "account.note.edit_button": "Modifica",
  "account.note.title": "Nota personale (visibile solo per te)",
  "account.open_original_page": "Apri la pagina originale",
  "account.pending": "In attesa",
  "account.posts": "Post",
  "account.remove_from_followers": "Rimuovi {name} dai follower",
  "account.report": "Segnala @{name}",
  "account.requested_follow": "{name} ha richiesto di seguirti",
  "account.share": "Condividi il profilo di @{name}",
  "account.show_reblogs": "Mostra condivisioni da @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} post} other {{counter} post}}",
  "account.timeline.pinned": "Fissato",
  "account.timeline.pinned.view_all": "Visualizza tutti i post fissati",
  "account.unblock": "Sblocca @{name}",
  "account.unblock_domain": "Sblocca il dominio {domain}",
  "account.unblock_domain_short": "Sblocca",
  "account.unblock_short": "Sblocca",
  "account.unendorse": "Non mostrare sul profilo",
  "account.unfollow": "Smetti di seguire",
  "account.unmute": "Riattiva @{name}",
  "account.unmute_notifications_short": "Riattiva notifiche",
  "account.unmute_short": "Riattiva",
  "account_edit.advanced_settings.bot_hint": "Segnala ad altri che l'account esegue principalmente azioni automatizzate e potrebbe non essere monitorato",
  "account_edit.advanced_settings.bot_label": "Account automatizzato",
  "account_edit.advanced_settings.title": "Impostazioni avanzate",
  "account_edit.bio.add_label": "Aggiungi biografia",
  "account_edit.bio.edit_label": "Modifica la biografia",
  "account_edit.bio.placeholder": "Aggiungi una breve introduzione per aiutare gli altri a identificarti.",
  "account_edit.bio.title": "Biografia",
  "account_edit.bio_modal.add_title": "Aggiungi biografia",
  "account_edit.bio_modal.edit_title": "Modifica la biografia",
  "account_edit.column_button": "Fatto",
  "account_edit.column_title": "Modifica il profilo",
  "account_edit.custom_fields.add_label": "Aggiungi un campo",
  "account_edit.custom_fields.edit_label": "Modifica il campo",
  "account_edit.custom_fields.placeholder": "Aggiungi i tuoi pronomi, collegamenti esterni o qualsiasi altra cosa desideri condividere.",
  "account_edit.custom_fields.reorder_button": "Riordina i campi",
  "account_edit.custom_fields.tip_content": "Puoi facilmente aggiungere credibilità al tuo account Mastodon, verificando i collegamenti a qualsiasi sito web di tua proprietà.",
  "account_edit.custom_fields.tip_title": "Suggerimento: aggiunta di collegamenti verificati",
  "account_edit.custom_fields.title": "Campi personalizzati",
  "account_edit.custom_fields.verified_hint": "Come aggiungo un collegamento verificato?",
  "account_edit.display_name.add_label": "Aggiungi il nome mostrato",
  "account_edit.display_name.edit_label": "Modifica il nome mostrato",
  "account_edit.display_name.placeholder": "Il tuo nome mostrato è il modo in cui il tuo nome appare sul tuo profilo e nelle timeline.",
  "account_edit.display_name.title": "Nome mostrato",
  "account_edit.featured_hashtags.edit_label": "Aggiungi hashtag",
  "account_edit.featured_hashtags.placeholder": "Aiuta gli altri a identificare e ad accedere rapidamente ai tuoi argomenti preferiti.",
  "account_edit.featured_hashtags.title": "Hashtag in evidenza",
  "account_edit.field_actions.delete": "Elimina il campo",
  "account_edit.field_actions.edit": "Modifica il campo",
  "account_edit.field_delete_modal.confirm": "Si è sicuri di voler eliminare questo campo personalizzato? Questa azione non può essere annullata.",
  "account_edit.field_delete_modal.delete_button": "Elimina",
  "account_edit.field_delete_modal.title": "Eliminare il campo personalizzato?",
  "account_edit.field_edit_modal.add_title": "Aggiungi campo personalizzato",
  "account_edit.field_edit_modal.discard_confirm": "Abbandona",
  "account_edit.field_edit_modal.discard_message": "Sono presenti modifiche non salvate. Vuoi davvero eliminarle?",
  "account_edit.field_edit_modal.edit_title": "Modifica campo personalizzato",
  "account_edit.field_edit_modal.length_warning": "Il limite di caratteri raccomandato è stato superato. Gli utenti da dispositivi mobili potrebbero non visualizzare il tuo campo per intero.",
  "account_edit.field_edit_modal.link_emoji_warning": "Sconsigliamo l'uso di emoji personalizzate in combinazione con gli URL. I campi personalizzati che contengono entrambi verranno visualizzati solo come testo anziché come link, in modo da evitare confusione nell'utente.",
  "account_edit.field_edit_modal.name_hint": "Per esempio: \"Sito web personale\"",
  "account_edit.field_edit_modal.name_label": "Etichetta",
  "account_edit.field_edit_modal.url_warning": "Per aggiungere un collegamento, si prega di includere {protocol} all’inizio.",
  "account_edit.field_edit_modal.value_hint": "Per esempio: \"https://example.me\"",
  "account_edit.field_edit_modal.value_label": "Valore",
  "account_edit.field_reorder_modal.drag_cancel": "Il trascinamento è stato annullato. Il campo \"{item}\" è stato eliminato.",
  "account_edit.field_reorder_modal.drag_end": "Il campo \"{item}\" è stato eliminato.",
  "account_edit.field_reorder_modal.drag_instructions": "Per riorganizzare i campi personalizzati, premi la barra spaziatrice o Invio. Durante il trascinamento, usa i tasti freccia per spostare il campo verso l'alto o verso il basso. Premi di nuovo la barra spaziatrice o Invio per rilasciare il campo nella sua nuova posizione, oppure premi Esc per annullare.",
  "account_edit.field_reorder_modal.drag_move": "Il campo \"{item}\" è stato spostato.",
  "account_edit.field_reorder_modal.drag_over": "Il campo \"{item}\" è stato spostato su \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Campo \"{item}\" selezionato.",
  "account_edit.field_reorder_modal.handle_label": "Trascina il campo \"{item}\"",
  "account_edit.field_reorder_modal.title": "Riorganizza i campi",
  "account_edit.image_alt_modal.add_title": "Aggiungi il testo alternativo",
  "account_edit.image_alt_modal.details_content": "COSA FARE: <ul> <li>Descriviti come nella foto</li> <li>Usa la terza persona (es. “Alex” invece di “io”)</li> <li>Sii conciso/a – poche parole spesso bastano</li> </ul> COSA NON FARE: <ul> <li>Iniziare con “Foto di” – è ridondante per i lettori di schermo</li> </ul> ESEMPIO: <ul> <li>“Alex sta indossando una camicia verde e gli occhiali”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Suggerimenti: testo alternativo per le foto del profilo",
  "account_edit.image_alt_modal.edit_title": "Modifica il testo alternativo",
  "account_edit.image_alt_modal.text_hint": "Il testo alternativo aiuta gli utenti che utilizzano i lettori di schermo a comprendere i tuoi contenuti.",
  "account_edit.image_alt_modal.text_label": "Testo alternativo",
  "account_edit.image_delete_modal.confirm": "Si è sicuri di voler eliminare questa immagine? Questa azione non può essere annullata.",
  "account_edit.image_delete_modal.delete_button": "Elimina",
  "account_edit.image_delete_modal.title": "Eliminare l'immagine?",
  "account_edit.image_edit.add_button": "Aggiungi un'immagine",
  "account_edit.image_edit.alt_add_button": "Aggiungi il testo alternativo",
  "account_edit.image_edit.alt_edit_button": "Modifica il testo alternativo",
  "account_edit.image_edit.remove_button": "Rimuovi l'immagine",
  "account_edit.image_edit.replace_button": "Sostituisci l'immagine",
  "account_edit.item_list.delete": "Elimina {name}",
  "account_edit.item_list.edit": "Modifica {name}",
  "account_edit.name_modal.add_title": "Aggiungi il nome mostrato",
  "account_edit.name_modal.edit_title": "Modifica il nome mostrato",
  "account_edit.profile_tab.button_label": "Personalizza",
  "account_edit.profile_tab.hint.description": "Queste impostazioni personalizzano ciò che gli utenti vedono su {server} nelle app ufficiali, ma potrebbero non applicarsi agli utenti su altri server e app di terze parti.",
  "account_edit.profile_tab.hint.title": "La visualizzazione può variare",
  "account_edit.profile_tab.show_featured.description": "\"In evidenza\" è una scheda opzionale in cui puoi mostrare altri account.",
  "account_edit.profile_tab.show_featured.title": "Mostra la scheda \"In evidenza\"",
  "account_edit.profile_tab.show_media.description": "\"Media\" è una scheda opzionale che mostra i tuoi post contenenti immagini o video.",
  "account_edit.profile_tab.show_media.title": "Mostra la scheda \"Media\"",
  "account_edit.profile_tab.show_media_replies.description": "Quando abilitata, la scheda Media mostra sia i tuoi post che le risposte ai post di altre persone.",
  "account_edit.profile_tab.show_media_replies.title": "Includi le risposte nella scheda \"Media\"",
  "account_edit.profile_tab.show_relations.description": "Mostra gli account che segui e i follower ad altri utenti nel tuo profilo. Le persone saranno ancora in grado di vedere se li stai seguendo.",
  "account_edit.profile_tab.show_relations.title": "Mostra \"Followers\" e \"Seguiti\"",
  "account_edit.profile_tab.subtitle": "Personalizza come viene visualizzato il tuo profilo.",
  "account_edit.profile_tab.title": "Impostazioni di visualizzazione del profilo",
  "account_edit.save": "Salva",
  "account_edit.upload_modal.back": "Indietro",
  "account_edit.upload_modal.done": "Fatto",
  "account_edit.upload_modal.next": "Avanti",
  "account_edit.upload_modal.step_crop.zoom": "Ingrandimento",
  "account_edit.upload_modal.step_upload.button": "Sfoglia i file",
  "account_edit.upload_modal.step_upload.dragging": "Trascina per caricare",
  "account_edit.upload_modal.step_upload.header": "Scegli un'immagine",
  "account_edit.upload_modal.step_upload.hint": "Formato WEBP, PNG, GIF o JPG, fino a {limit}MB.{br}L'immagine verrà ridimensionata a {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Aggiungi la foto del profilo",
  "account_edit.upload_modal.title_add.header": "Aggiungi la foto di copertina",
  "account_edit.upload_modal.title_replace.avatar": "Sostituisci la foto del profilo",
  "account_edit.upload_modal.title_replace.header": "Sostituisci la foto di copertina",
  "account_edit.verified_modal.details": "Aggiungi credibilità al tuo profilo Mastodon verificando i collegamenti ai siti web personali. Ecco come funziona:",
  "account_edit.verified_modal.invisible_link.details": "Aggiungi il collegamento alla tua intestazione. La parte importante è rel=\"me\" che impedisce l'impersonificazione sui siti web con contenuti generati dagli utenti. Puoi anche utilizzare un link tag nell'intestazione della pagina al posto di {tag}, ma il codice HTML deve essere accessibile senza eseguire JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Come faccio a rendere il collegamento invisibile?",
  "account_edit.verified_modal.step1.header": "Copia il codice HTML qui sotto e incollalo nell'intestazione del tuo sito web",
  "account_edit.verified_modal.step2.details": "Se hai già aggiunto il tuo sito web come campo personalizzato, dovrai eliminarlo e aggiungerlo di nuovo per attivare la verifica.",
  "account_edit.verified_modal.step2.header": "Aggiungi il tuo sito web come campo personalizzato",
  "account_edit.verified_modal.title": "Come aggiungere un collegamento verificato",
  "account_edit_tags.add_tag": "Aggiungi #{tagName}",
  "account_edit_tags.column_title": "Modifica i tag",
  "account_edit_tags.help_text": "Gli hashtag in evidenza aiutano gli utenti a scoprire e interagire con il tuo profilo. Appaiono come filtri nella visualizzazione Attività della tua pagina del profilo.",
  "account_edit_tags.max_tags_reached": "Hai raggiunto il numero massimo di hashtag in evidenza.",
  "account_edit_tags.search_placeholder": "Inserisci un hashtag…",
  "account_edit_tags.suggestions": "Suggerimenti:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# post} other {# post}}",
  "account_list.hidden_notice": "Questo è visibile solo a te. Per mostrare questa lista ad altri, vai su <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# account} other {# account}}",
  "admin.dashboard.daily_retention": "Tasso di ritenzione dell'utente per giorno, dopo la registrazione",
  "admin.dashboard.monthly_retention": "Tasso di ritenzione dell'utente per mese, dopo la registrazione",
  "admin.dashboard.retention.average": "Media",
  "admin.dashboard.retention.cohort": "Mese d'iscrizione",
  "admin.dashboard.retention.cohort_size": "Nuovi utenti",
  "admin.impact_report.instance_accounts": "Profili di account che questo eliminerebbe",
  "admin.impact_report.instance_followers": "I follower che i nostri utenti perderebbero",
  "admin.impact_report.instance_follows": "I follower che i loro utenti perderebbero",
  "admin.impact_report.title": "Riepilogo dell'impatto",
  "alert.need_reload.message": "Mastodon è stato aggiornato. Alcune funzionalità potrebbero non funzionare correttamente finché non ricarichi la pagina.",
  "alert.rate_limited.message": "Sei pregato di riprovare dopo le {retry_time, time, medium}.",
  "alert.rate_limited.title": "Limitazione per eccesso di richieste",
  "alert.unexpected.message": "Si è verificato un errore imprevisto.",
  "alert.unexpected.title": "Oops!",
  "alt_text_badge.title": "Testo alternativo",
  "alt_text_modal.add_alt_text": "Aggiungi testo alternativo",
  "alt_text_modal.add_text_from_image": "Aggiungi testo dall'immagine",
  "alt_text_modal.cancel": "Annulla",
  "alt_text_modal.change_thumbnail": "Cambia la miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Descrivi questo per le persone con disturbi dell'udito…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Descrivi questo per le persone con disabilità visive…",
  "alt_text_modal.done": "Fatto",
  "announcement.announcement": "Annuncio",
  "annual_report.announcement.action_build": "Costruisci il mio Wrapstodon",
  "annual_report.announcement.action_dismiss": "No, grazie",
  "annual_report.announcement.action_view": "Visualizza il mio Wrapstodon",
  "annual_report.announcement.description": "Scopri di più sul tuo coinvolgimento su Mastodon nell'ultimo anno.",
  "annual_report.announcement.title": "Wrapstodon {year} è arrivato",
  "annual_report.nav_item.badge": "Nuovo",
  "annual_report.shared_page.donate": "Dona",
  "annual_report.shared_page.footer": "Generato con {heart} dal team di Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} usa {domain}, una delle tante comunità basate su Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} è rimasto/a alla ricerca di post da condividere, amplificando il lavoro di altri creatori con precisione mirata.",
  "annual_report.summary.archetype.booster.desc_self": "Sei rimasto/a alla ricerca di post da condividere, amplificando il lavoro di altri creatori con precisione mirata.",
  "annual_report.summary.archetype.booster.name": "L'Arciere",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Sappiamo che {name} era là fuori, da qualche parte, a godersi Mastodon in tutta tranquillità.",
  "annual_report.summary.archetype.lurker.desc_self": "Sappiamo che eri là fuori, da qualche parte, a goderti Mastodon in tutta tranquillità.",
  "annual_report.summary.archetype.lurker.name": "Lo Stoico",
  "annual_report.summary.archetype.oracle.desc_public": "{name} ha creato più nuovi post che risposte, mantenendo Mastodon fresco e orientato al futuro.",
  "annual_report.summary.archetype.oracle.desc_self": "Hai creato più nuovi post che risposte, mantenendo Mastodon fresco e orientato al futuro.",
  "annual_report.summary.archetype.oracle.name": "L'Oracolo",
  "annual_report.summary.archetype.pollster.desc_public": "{name} ha creato più sondaggi rispetto ad altri tipi di post, alimentando la curiosità su Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Hai creato più sondaggi rispetto ad altri tipi di post, alimentando la curiosità su Mastodon.",
  "annual_report.summary.archetype.pollster.name": "L'Esploratore",
  "annual_report.summary.archetype.replier.desc_public": "{name} ha frequentemente risposto ai post di altre persone, alimentando Mastodon con nuove discussioni.",
  "annual_report.summary.archetype.replier.desc_self": "Hai frequentemente risposto ai post di altre persone, alimentando Mastodon con nuove discussioni.",
  "annual_report.summary.archetype.replier.name": "La Farfalla",
  "annual_report.summary.archetype.reveal": "Rivela il mio archetipo",
  "annual_report.summary.archetype.reveal_description": "Grazie per far parte di Mastodon! È il momento di scoprire quale archetipo hai incarnato nel {year}.",
  "annual_report.summary.archetype.title_public": "Archetipo di {name}",
  "annual_report.summary.archetype.title_self": "Il tuo archetipo",
  "annual_report.summary.close": "Chiudi",
  "annual_report.summary.copy_link": "Copia il сollegamento",
  "annual_report.summary.followers.new_followers": "{count, plural, one {nuovo follower} other {nuovi follower}}",
  "annual_report.summary.highlighted_post.boost_count": "Questo post è stato condiviso {count, plural, one {1 volta} other {# volte}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Questo post è stato aggiunto ai preferiti {count, plural, one {1 volta} other {# volte}}.",
  "annual_report.summary.highlighted_post.reply_count": "Questo post ha ricevuto {count, plural, one {1 risposta} other {# risposte}}.",
  "annual_report.summary.highlighted_post.title": "Il post più popolare",
  "annual_report.summary.most_used_app.most_used_app": "l'app più utilizzata",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "l'hashtag più usato",
  "annual_report.summary.most_used_hashtag.used_count": "Hai incluso questo hashtag in {count, plural, one {1 post} other {# post}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} ha incluso questo hashtag in {count, plural, one {1 post} other {# post}}.",
  "annual_report.summary.new_posts.new_posts": "nuovi post",
  "annual_report.summary.percentile.text": "<topLabel>Ciò ti colloca in cima</topLabel><percentage></percentage><bottomLabel>agli utenti di {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Non lo diremo a Bernie.",
  "annual_report.summary.share_elsewhere": "Condividi altrove",
  "annual_report.summary.share_message": "Ho ottenuto l'archetipo: {archetype}!",
  "annual_report.summary.share_on_mastodon": "Condividi su Mastodon",
  "attachments_list.unprocessed": "(non elaborato)",
  "audio.hide": "Nascondi audio",
  "block_modal.no_collections": "Nessuno dei due può aggiungere l'altro alle rispettive collezioni. Verrete automaticamente rimossi dalle collezioni esistenti dell'altro, se presenti.",
  "block_modal.remote_users_caveat": "Chiederemo al server {domain} di rispettare la tua decisione. Tuttavia, la conformità non è garantita poiché alcuni server potrebbero gestire i blocchi in modo diverso. I post pubblici potrebbero essere ancora visibili agli utenti che non hanno effettuato l'accesso.",
  "block_modal.show_less": "Mostra meno",
  "block_modal.show_more": "Mostra di più",
  "block_modal.they_cant_mention": "Non potrete menzionarvi, seguirvi o citarvi a vicenda.",
  "block_modal.they_cant_see_posts": "Non potrà vedere i tuoi contenuti e tu non potrai vedere i suoi.",
  "block_modal.they_will_know": "Può vedere che è stato/a bloccato/a.",
  "block_modal.title": "Bloccare l'utente?",
  "block_modal.you_wont_see_mentions": "Non vedrai post da altri che menzionano l'utente.",
  "boost_modal.combo": "Puoi premere {combo} per saltare questo passaggio, la prossima volta",
  "boost_modal.reblog": "Condividere il post?",
  "boost_modal.undo_reblog": "Annullare la condivisione del post?",
  "bundle_column_error.copy_stacktrace": "Copia rapporto sull'errore",
  "bundle_column_error.error.body": "Impossibile rendedrizzare la pagina richiesta. Potrebbe dipendere da un bug nel nostro codice o da un problema di compatibilità di un browser.",
  "bundle_column_error.error.title": "Oh, no!",
  "bundle_column_error.network.body": "C'è stato un errore durante il caricamento di questa pagina. Potrebbe essere dovuto a un problema temporaneo con la tua connessione internet o a questo server.",
  "bundle_column_error.network.title": "Errore di rete",
  "bundle_column_error.retry": "Riprova",
  "bundle_column_error.return": "Torna alla home",
  "bundle_column_error.routing.body": "Impossibile trovare la pagina richiesta. Sei sicuro che l'URL nella barra degli indirizzi sia corretto?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Chiudi",
  "bundle_modal_error.message": "Si è verificato un errore durante il caricamento di questa schermata.",
  "bundle_modal_error.retry": "Riprova",
  "callout.dismiss": "Ignora",
  "carousel.current": "<sr>Diapositiva</sr> {current, number} / {max, number}",
  "carousel.slide": "Diapositiva {current, number} di {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} caratteri consigliati",
  "character_counter.required": "{currentLength}/{maxLength} caratteri",
  "closed_registrations.other_server_instructions": "Poiché Mastodon è decentralizzato, puoi creare un profilo su un altro server, pur continuando a interagire con questo.",
  "closed_registrations_modal.description": "Correntemente, è impossibile creare un profilo su {domain}, ma sei pregato di tenere presente che non necessiti di un profilo specificamente su {domain} per utilizzare Mastodon.",
  "closed_registrations_modal.find_another_server": "Trova un altro server",
  "closed_registrations_modal.preamble": "Mastodon è decentralizzato, quindi, non importa dove crei il tuo profilo, potrai seguire e interagire con chiunque su questo server. Anche se sei tu stesso a ospitarlo!",
  "closed_registrations_modal.title": "Registrazione su Mastodon",
  "collection.share_modal.share_link_label": "Condividi il link",
  "collection.share_modal.share_via_post": "Pubblica su Mastodon",
  "collection.share_modal.share_via_system": "Condividi con…",
  "collection.share_modal.title": "Condividi la collezione",
  "collection.share_modal.title_new": "Condividi la tua nuova collezione!",
  "collection.share_template_other": "Dai un'occhiata a questa fantastica collezione:",
  "collection.share_template_own": "Dai un'occhiata alla mia nuova collezione:",
  "collections.account_count": "{count, plural, one {# account} other {# account}}",
  "collections.accounts.empty_description": "Aggiungi fino a {count} account",
  "collections.accounts.empty_editor_title": "Nessuno è ancora in questa collezione",
  "collections.accounts.empty_title": "Questa collezione è vuota",
  "collections.add_to_collection": "Aggiungi {name} alle collezioni",
  "collections.block_collection_owner": "Blocca l'account",
  "collections.by_account": "di {account_handle}",
  "collections.collection_description": "Descrizione",
  "collections.collection_language": "Lingua",
  "collections.collection_language_none": "Nessuna",
  "collections.collection_name": "Nome",
  "collections.collection_topic": "Argomento",
  "collections.confirm_account_removal": "Si è sicuri di voler rimuovere questo account da questa collezione?",
  "collections.content_warning": "Avviso sul contenuto",
  "collections.continue": "Continua",
  "collections.copy_link": "Copia il сollegamento",
  "collections.copy_link_confirmation": "Collegamento della collezione copiato negli appunti",
  "collections.create.accounts_title": "Chi includerai in questa collezione?",
  "collections.create.basic_details_title": "Dettagli di base",
  "collections.create.steps": "Step {step}/{total}",
  "collections.create_collection": "Crea la collezione",
  "collections.create_new_collection": "Crea una nuova collezione",
  "collections.delete_collection": "Cancella la collezione",
  "collections.description_length_hint": "Limite di 100 caratteri",
  "collections.detail.author_added_you_on_date": "{author} ti ha aggiunto/a in data: {date}",
  "collections.detail.loading": "Caricamento della collezione…",
  "collections.detail.revoke_inclusion": "Rimuovimi",
  "collections.detail.sensitive_content": "Contenuto sensibile",
  "collections.detail.sensitive_note": "La descrizione e gli account potrebbero non essere adatti a tutti i tipi di pubblico.",
  "collections.detail.share": "Condividi questa collezione",
  "collections.detail.you_are_in_this_collection": "Sei presente in questa collezione",
  "collections.edit_details": "Modifica i dettagli",
  "collections.error_loading_collections": "Si è verificato un errore durante il tentativo di caricare queste collezioni.",
  "collections.hidden_accounts_description": "Hai bloccato o silenziato {count, plural, one {questo utente} other {questi utenti}}",
  "collections.hidden_accounts_link": "{count, plural, one {# account nascosto} other {# account nascosti}}",
  "collections.hints.accounts_counter": "{count}/{max} account",
  "collections.last_updated_at": "Ultimo aggiornamento: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# collezione} other {# collezioni}}",
  "collections.list.created_by_author": "Create da {name}",
  "collections.list.created_by_you": "Create da te",
  "collections.list.featuring_you": "Con te",
  "collections.manage_accounts": "Gestisci account",
  "collections.mark_as_sensitive": "Segna come sensibile",
  "collections.mark_as_sensitive_hint": "Nasconde la descrizione e gli account della collezione dietro un avviso di contenuto. Il nome della collezione rimarrà visibile.",
  "collections.maximum_collection_count_description": "Il tuo server consente la creazione di un massimo di {count} collezioni.",
  "collections.maximum_collection_count_reached": "Hai creato il numero massimo di collezioni",
  "collections.name_length_hint": "Limite di 40 caratteri",
  "collections.new_collection": "Nuova collezione",
  "collections.pending_accounts.message": "Gli account potrebbero apparire in attesa quando stiamo aspettando una risposta dall'utente o dal suo server. Solo tu puoi visualizzare gli account in attesa.",
  "collections.pending_accounts.title": "Perché sto vedendo gli account in attesa?",
  "collections.remove_account": "Rimuovi",
  "collections.report_collection": "Segnala questa collezione",
  "collections.revoke_collection_inclusion": "Rimuovimi da questa collezione",
  "collections.revoke_inclusion.confirmation": "Sei stato/a rimosso/a da \"{collection}\"",
  "collections.revoke_inclusion.error": "Si è verificato un errore, si prega di riprovare più tardi.",
  "collections.search_accounts_label": "Cerca un account da aggiungere",
  "collections.search_accounts_max_reached": "Hai aggiunto il numero massimo di account",
  "collections.sensitive": "Sensibile",
  "collections.share_short": "Condividi",
  "collections.sort_alphabetical": "Ordine alfabetico",
  "collections.sort_by": "Ordina per:",
  "collections.sort_date_added": "Data di aggiunta",
  "collections.sort_last_active": "Ultima attività",
  "collections.sort_most_followers": "Più follower",
  "collections.suggestions.can_not_add": "Non può essere aggiunto",
  "collections.suggestions.can_not_add_desc": "Questi account potrebbero aver scelto di non essere scoperti, oppure potrebbero trovarsi su un server che non supporta le collezioni.",
  "collections.suggestions.must_follow": "Devi prima seguire",
  "collections.suggestions.must_follow_desc": "Questi account esaminano tutte le richieste di essere seguiti. I follower possono aggiungerli alle collezioni.",
  "collections.topic_hint": "Aggiungi un hashtag che aiuti gli altri a comprendere l'argomento principale di questa collezione.",
  "collections.topic_special_chars_hint": "I caratteri speciali verranno rimossi durante il salvataggio",
  "collections.unlisted_collections_description": "Queste collezioni non sono visibili agli altri sul tuo profilo. Chiunque abbia i link può trovarle.",
  "collections.unlisted_collections_with_count": "Collezioni non elencate ({count})",
  "collections.view_collection": "Visualizza la collezione",
  "collections.visibility_public": "Pubblica",
  "collections.visibility_public_hint": "Individuabile nei risultati di ricerca e in altre aree in cui compaiono i suggerimenti.",
  "collections.visibility_title": "Visibilità",
  "collections.visibility_unlisted": "Non elencata",
  "collections.visibility_unlisted_hint": "Visibile a chiunque abbia un link. Nascosto dai risultati di ricerca e dai suggerimenti.",
  "column.about": "Info",
  "column.blocks": "Utenti bloccati",
  "column.bookmarks": "Segnalibri",
  "column.community": "Cronologia locale",
  "column.create_list": "Crea lista",
  "column.direct": "Menzioni private",
  "column.directory": "Sfoglia i profili",
  "column.domain_blocks": "Domini bloccati",
  "column.edit_list": "Modifica lista",
  "column.favourites": "Apprezzamenti",
  "column.firehose": "Feed in diretta",
  "column.firehose_local": "Feed in diretta per questo server",
  "column.firehose_singular": "Feed in diretta",
  "column.follow_requests": "Richieste di seguirti",
  "column.home": "Home",
  "column.list_members": "Gestisci i membri della lista",
  "column.lists": "Liste",
  "column.mutes": "Utenti silenziati",
  "column.notifications": "Notifiche",
  "column.other_collections": "Collezioni di {name}",
  "column.pins": "Post fissati",
  "column.public": "Timeline federata",
  "column.your_collections": "Le tue collezioni",
  "column_back_button.label": "Indietro",
  "column_header.hide_settings": "Nascondi impostazioni",
  "column_header.moveLeft_settings": "Sposta colonna a sinistra",
  "column_header.moveRight_settings": "Sposta colonna a destra",
  "column_header.pin": "Fissa",
  "column_header.show_settings": "Mostra le impostazioni",
  "column_header.unpin": "Non fissare",
  "column_search.cancel": "Annulla",
  "combobox.close_results": "Chiudi i risultati",
  "combobox.loading": "Caricamento in corso",
  "combobox.no_results_found": "Nessun risultato per questa ricerca",
  "combobox.open_results": "Apri i risultati",
  "combobox.results_available": "{count, plural, one {# suggerimento} other {# suggerimenti}} disponibile/i. Utilizzare i tasti freccia su e freccia giù per navigare. Premere Invio per selezionare.",
  "community.column_settings.local_only": "Solo Locale",
  "community.column_settings.media_only": "Solo Media",
  "community.column_settings.remote_only": "Solo Remoto",
  "compose.error.blank_post": "Il post non può essere vuoto.",
  "compose.language.change": "Cambia la lingua",
  "compose.language.search": "Cerca lingue...",
  "compose.published.body": "Post pubblicato.",
  "compose.published.open": "Apri",
  "compose.saved.body": "Post salvato.",
  "compose_form.direct_message_warning_learn_more": "Scopri di più",
  "compose_form.encryption_warning": "I post su Mastodon non sono crittografati end-to-end. Non condividere alcuna informazione sensibile su Mastodon.",
  "compose_form.hashtag_warning": "Questo post non sarà elencato sotto alcun hashtag, poiché non è pubblico. Solo i post pubblici possono essere cercati per hashtag.",
  "compose_form.lock_disclaimer": "Il tuo profilo non è {locked}. Chiunque può seguirti per visualizzare i tuoi post per soli follower.",
  "compose_form.lock_disclaimer.lock": "bloccato",
  "compose_form.placeholder": "Cos'hai in mente?",
  "compose_form.poll.duration": "Durata del sondaggio",
  "compose_form.poll.multiple": "Scelta multipla",
  "compose_form.poll.option_placeholder": "Opzione {number}",
  "compose_form.poll.single": "Scelta singola",
  "compose_form.poll.switch_to_multiple": "Modifica il sondaggio per consentire scelte multiple",
  "compose_form.poll.switch_to_single": "Modifica il sondaggio per consentire una singola scelta",
  "compose_form.poll.type": "Stile",
  "compose_form.publish": "Pubblica",
  "compose_form.reply": "Rispondi",
  "compose_form.save_changes": "Aggiorna",
  "compose_form.spoiler.marked": "Rimuovi l'avviso del contenuto",
  "compose_form.spoiler.unmarked": "Aggiungi l'avviso del contenuto",
  "compose_form.spoiler_placeholder": "Contenuto sensibile (facoltativo)",
  "confirmation_modal.cancel": "Annulla",
  "confirmations.block.confirm": "Blocca",
  "confirmations.delete.confirm": "Elimina",
  "confirmations.delete.message": "Sei sicuro di voler eliminare questo post?",
  "confirmations.delete.title": "Eliminare il post?",
  "confirmations.delete_collection.confirm": "Cancella",
  "confirmations.delete_collection.message": "Questa azione non può essere annullata.",
  "confirmations.delete_collection.title": "Cancellare \"{name}\"?",
  "confirmations.delete_list.confirm": "Elimina",
  "confirmations.delete_list.message": "Sei sicuro/a di voler eliminare permanentemente questo elenco?",
  "confirmations.delete_list.title": "Eliminare la lista?",
  "confirmations.discard_draft.confirm": "Scarta e continua",
  "confirmations.discard_draft.edit.cancel": "Continua modifica",
  "confirmations.discard_draft.edit.message": "Continuare scarterà ogni modifica che hai fatto al post che stai attualmente modificando.",
  "confirmations.discard_draft.edit.title": "Scartare le modifiche al tuo post?",
  "confirmations.discard_draft.post.cancel": "Continua bozza",
  "confirmations.discard_draft.post.message": "Continuare scarterà il post che stai attualmente creando.",
  "confirmations.discard_draft.post.title": "Scartare la tua bozza del post?",
  "confirmations.discard_edit_media.confirm": "Scarta",
  "confirmations.discard_edit_media.message": "Hai delle modifiche non salvate alla descrizione o anteprima del media, scartarle comunque?",
  "confirmations.follow_to_list.confirm": "Segui e aggiungi alla lista",
  "confirmations.follow_to_list.message": "Devi seguire {name} per aggiungerli a una lista.",
  "confirmations.follow_to_list.title": "Seguire l'utente?",
  "confirmations.hide_featured_tab.confirm": "Nascondi la scheda",
  "confirmations.hide_featured_tab.intro": "Puoi modificare questa impostazione in qualsiasi momento in <i>Modifica profilo > Impostazioni della scheda del profilo</i>.",
  "confirmations.hide_featured_tab.message": "Questa opzione nasconderà la scheda per gli utenti su {serverName} e su altri server che eseguono l'ultima versione di Mastodon. Per gli altri utenti, la visualizzazione potrebbe variare.",
  "confirmations.hide_featured_tab.title": "Nascondere la scheda \"In evidenza\"?",
  "confirmations.logout.confirm": "Disconnettiti",
  "confirmations.logout.message": "Sei sicuro di volerti disconnettere?",
  "confirmations.logout.title": "Uscire?",
  "confirmations.missing_alt_text.confirm": "Aggiungi testo alternativo",
  "confirmations.missing_alt_text.message": "Il tuo post contiene media senza testo alternativo. L'aggiunta di descrizioni aiuta a rendere i tuoi contenuti accessibili a più persone.",
  "confirmations.missing_alt_text.secondary": "Pubblica comunque",
  "confirmations.missing_alt_text.title": "Aggiungere testo alternativo?",
  "confirmations.mute.confirm": "Silenzia",
  "confirmations.private_quote_notify.cancel": "Torna a modificare",
  "confirmations.private_quote_notify.confirm": "Pubblica il post",
  "confirmations.private_quote_notify.do_not_show_again": "Non mostrarmi più questo messaggio",
  "confirmations.private_quote_notify.message": "La persona che stai citando e le altre persone menzionate riceveranno una notifica e potranno visualizzare il tuo post, anche se non ti stanno seguendo.",
  "confirmations.private_quote_notify.title": "Condividere con i follower e gli utenti menzionati?",
  "confirmations.quiet_post_quote_info.dismiss": "Non ricordarmelo più",
  "confirmations.quiet_post_quote_info.got_it": "Ho capito",
  "confirmations.quiet_post_quote_info.message": "Quando citi un post pubblico silenzioso, il tuo post verrà nascosto dalle timeline di tendenza.",
  "confirmations.quiet_post_quote_info.title": "Citazione di post pubblici silenziosi",
  "confirmations.redraft.confirm": "Elimina e riscrivi",
  "confirmations.redraft.message": "Sei sicuro di voler eliminare questo post e riscriverlo? I post aggiunti ai preferiti e condivisi andranno persi e le risposte al post originale non saranno più collegate.",
  "confirmations.redraft.title": "Eliminare e riformulare il post?",
  "confirmations.remove_from_followers.confirm": "Rimuovi il follower",
  "confirmations.remove_from_followers.message": "{name} smetterà di seguirti. Si è sicuri di voler procedere?",
  "confirmations.remove_from_followers.title": "Rimuovere il follower?",
  "confirmations.revoke_collection_inclusion.confirm": "Rimuovimi",
  "confirmations.revoke_collection_inclusion.message": "L'account che gestisce la collezione non potrà aggiungerti nuovamente per 24 ore. Per impedirgli definitivamente di aggiungerti alle collezioni, puoi bloccarlo.",
  "confirmations.revoke_collection_inclusion.title": "Rimuovere te stesso/a da questa collezione?",
  "confirmations.revoke_quote.confirm": "Elimina il post",
  "confirmations.revoke_quote.message": "Questa azione non può essere annullata.",
  "confirmations.revoke_quote.title": "Rimuovere il post?",
  "confirmations.unblock.confirm": "Sblocca",
  "confirmations.unblock.title": "Sbloccare {name}?",
  "confirmations.unfollow.confirm": "Smetti di seguire",
  "confirmations.unfollow.title": "Smettere di seguire {name}?",
  "confirmations.withdraw_request.confirm": "Annulla la richiesta",
  "confirmations.withdraw_request.title": "Annullare la richiesta di seguire {name}?",
  "content_warning.hide": "Nascondi post",
  "content_warning.show": "Mostra comunque",
  "content_warning.show_more": "Mostra di più",
  "content_warning.show_short": "Mostra",
  "conversation.delete": "Elimina conversazione",
  "conversation.mark_as_read": "Segna come letto",
  "conversation.open": "Visualizza conversazione",
  "conversation.with": "Con {names}",
  "copy_icon_button.copied": "Copiato negli appunti",
  "copy_icon_button.copy_this_text": "Copia il collegamento negli appunti",
  "copypaste.copied": "Copiato",
  "copypaste.copy_to_clipboard": "Copia negli Appunti",
  "custom_homepage.about": "Info",
  "custom_homepage.about_this_server": "Informazioni su questo server",
  "custom_homepage.administered_by": "Amministrato da",
  "custom_homepage.contact": "Contatto:",
  "custom_homepage.latest_activity": "Attività più recente",
  "custom_homepage.these_are_the_latest_posts": "Questi sono gli ultimi 40 post da account presenti su questo server.",
  "directory.federated": "Dal fediverso conosciuto",
  "directory.local": "Solo da {domain}",
  "directory.new_arrivals": "Nuovi arrivi",
  "directory.recently_active": "Attivo di recente",
  "disabled_account_banner.account_settings": "Impostazioni del profilo",
  "disabled_account_banner.text": "Il tuo profilo {disabledAccount} è correntemente disabilitato.",
  "dismissable_banner.community_timeline": "Questi sono i post pubblici più recenti da persone i cui profili sono ospitati da {domain}.",
  "dismissable_banner.dismiss": "Ignora",
  "dismissable_banner.public_timeline": "Questi sono i post pubblici più recenti pubblicati dalle persone sul fediverso che sono seguite dagli utenti su {domain}.",
  "domain_block_modal.block": "Blocca il server",
  "domain_block_modal.block_account_instead": "Blocca invece @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Le persone da questo server possono interagire con i tuoi vecchi post.",
  "domain_block_modal.they_cant_follow": "Nessuno da questo server può seguirti.",
  "domain_block_modal.they_wont_know": "Non sapranno di essere stati bloccati.",
  "domain_block_modal.title": "Bloccare il dominio?",
  "domain_block_modal.you_will_lose_num_followers": "Perderai {followersCount, plural, one {{followersCountDisplay} follower} other {{followersCountDisplay} follower}} e {followingCount, plural, one {{followingCountDisplay} persona che segui} other {{followingCountDisplay} persone che segui}}.",
  "domain_block_modal.you_will_lose_relationships": "Perderai tutti i follower e le persone che segui da questo server.",
  "domain_block_modal.you_wont_see_posts": "Non vedrai post o notifiche dagli utenti su questo server.",
  "dropdown.empty": "Seleziona un'opzione",
  "email_subscriptions.email": "Email",
  "email_subscriptions.form.action": "Iscriviti",
  "email_subscriptions.form.bottom": "Ricevi i post nella tua casella di posta elettronica senza creare un account Mastodon. Puoi disiscriverti in qualsiasi momento. Per maggiori informazioni, consulta l'<a>Informativa sulla privacy</a>.",
  "email_subscriptions.form.title": "Iscriviti per ricevere aggiornamenti via email da {name}",
  "email_subscriptions.submitted.lead": "Controlla la tua casella di posta elettronica per completare l'iscrizione agli aggiornamenti via email.",
  "email_subscriptions.submitted.title": "Ancora un passaggio",
  "email_subscriptions.validation.email.blocked": "Provider di posta elettronica bloccato",
  "email_subscriptions.validation.email.invalid": "Indirizzo email non valido",
  "embed.instructions": "Incorpora questo post sul tuo sito web, copiando il seguente codice.",
  "embed.preview": "Ecco come apparirà:",
  "emoji_button.activity": "Attività",
  "emoji_button.clear": "Cancella",
  "emoji_button.custom": "Personalizzato",
  "emoji_button.flags": "Bandiere",
  "emoji_button.food": "Cibo & Bevande",
  "emoji_button.label": "Inserisci emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Nessun emoji corrispondente",
  "emoji_button.objects": "Oggetti",
  "emoji_button.people": "Persone",
  "emoji_button.recent": "Usate frequentemente",
  "emoji_button.search": "Cerca...",
  "emoji_button.search_results": "Risultati della ricerca",
  "emoji_button.symbols": "Simboli",
  "emoji_button.travel": "Viaggi & Luoghi",
  "empty_column.account_featured.other": "{acct} non ha ancora messo nulla in evidenza.",
  "empty_column.account_featured_self.no_collections_button": "Crea una collezione",
  "empty_column.account_featured_self.no_collections_hide_tab": "Nascondi questa scheda invece",
  "empty_column.account_featured_self.showcase_accounts": "Mostra i tuoi account preferiti",
  "empty_column.account_featured_self.showcase_accounts_desc": "Le collezioni sono elenchi curati di account che aiutano gli altri utenti a scoprire di più sul fediverso.",
  "empty_column.account_featured_unknown.other": "Questo account non ha ancora presentato nulla.",
  "empty_column.account_hides_collections": "Questo utente ha scelto di non rendere disponibili queste informazioni",
  "empty_column.account_suspended": "Profilo sospeso",
  "empty_column.account_timeline": "Nessun post qui!",
  "empty_column.account_unavailable": "Profilo non disponibile",
  "empty_column.blocks": "Non hai ancora bloccato alcun utente.",
  "empty_column.bookmarked_statuses": "Non hai ancora aggiunto alcun post ai segnalibri. Quando ne aggiungerai uno, verrà visualizzato qui.",
  "empty_column.collections": "{acct} non ha ancora creato alcuna collezione.",
  "empty_column.collections.featured_in": "Non sei ancora stato/a aggiunto/a ad alcuna collezione.",
  "empty_column.collections.featured_in_undiscoverable": "Affinché le persone possano aggiungerti alle collezioni, è necessario consentire che il profilo sia visibile nelle esperienze di scoperta tramite <link>Preferenze > Privacy e visibilità</link>",
  "empty_column.collections_self": "Non hai ancora creato alcuna collezione.",
  "empty_column.community": "La cronologia locale è vuota. Scrivi qualcosa pubblicamente per dare inizio alla festa!",
  "empty_column.direct": "Non hai ancora alcuna menzione privata. Quando ne invierai o riceverai una, apparirà qui.",
  "empty_column.disabled_feed": "Questo feed è stato disabilitato dagli amministratori del tuo server.",
  "empty_column.domain_blocks": "Ancora nessun dominio bloccato.",
  "empty_column.explore_statuses": "Nulla è in tendenza al momento. Ricontrolla più tardi!",
  "empty_column.favourited_statuses": "Non hai ancora aggiunto nessun post ai preferiti. Quando ne aggiungerai uno, verrà visualizzato qui.",
  "empty_column.favourites": "Nessuno ha ancora messo questo post tra i preferiti. Quando qualcuno lo farà, apparirà qui.",
  "empty_column.follow_requests": "Non hai ancora alcuna richiesta di seguirti. Quando ne riceverai una, apparirà qui.",
  "empty_column.followed_tags": "Non hai ancora seguito alcun hashtag. Quando lo farai, appariranno qui.",
  "empty_column.hashtag": "Non c'è ancora nulla in questo hashtag.",
  "empty_column.home": "La cronologia della tua home è vuota! Segui altre persone per riempirla. {suggestions}",
  "empty_column.list": "Non c'è ancora nulla in questo elenco. Quando i membri di questo elenco pubblicheranno nuovi post, appariranno qui.",
  "empty_column.mutes": "Non hai ancora silenziato alcun utente.",
  "empty_column.notification_requests": "Tutto chiaro! Non c'è niente qui. Quando ricevi nuove notifiche, verranno visualizzate qui in base alle tue impostazioni.",
  "empty_column.notifications": "Non hai ancora nessuna notifica. Quando altre persone interagiranno con te, le vedrai qui.",
  "empty_column.public": "Non c'è nulla qui! Scrivi qualcosa pubblicamente o segui manualmente gli utenti dagli altri server per riempire questo spazio",
  "empty_state.no_results": "Nessun risultato",
  "error.no_hashtag_feed_access": "Iscriviti o accedi per visualizzare e seguire questo hashtag.",
  "error.unexpected_crash.explanation": "A causa di un bug nel nostro codice o di un problema di compatibilità del browser, non è stato possibile visualizzare correttamente questa pagina.",
  "error.unexpected_crash.explanation_addons": "Impossibile mostrare correttamente questa pagina. Questo errore è probabilmente causato da un addon del browser o da strumenti di traduzione automatica.",
  "error.unexpected_crash.next_steps": "Prova a ricaricare la pagina. Se non aiuta, potresti comunque utilizzare Mastodon tramite un browser differente o un'app nativa.",
  "error.unexpected_crash.next_steps_addons": "Prova a disabilitarli e a ricaricare la pagina. Se ciò non aiuta, potresti ancora utilizzare Mastodon tramite un browser differente o un'app nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copia stacktrace negli appunti",
  "errors.unexpected_crash.report_issue": "Segnala un problema",
  "explore.suggested_follows": "Persone",
  "explore.title": "Di tendenza",
  "explore.trending_links": "Notizie",
  "explore.trending_statuses": "Post",
  "explore.trending_tags": "Hashtag",
  "featured_carousel.current": "<sr>Post</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Post fissato} other {Post fissati}}",
  "featured_carousel.slide": "Post {current, number} di {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Ultimamente hai pubblicato contenuti relativi a {items}. Vuoi aggiungerli come hashtag in evidenza?",
  "featured_tags.suggestions.add": "Aggiungi",
  "featured_tags.suggestions.added": "Gestisci i tuoi hashtag in evidenza in qualsiasi momento in <link>Modifica profilo > Hashtag in evidenza</link>.",
  "featured_tags.suggestions.dismiss": "No, grazie",
  "filter_modal.added.context_mismatch_explanation": "La categoria di questo filtro non si applica al contesto in cui hai acceduto a questo post. Se desideri che il post sia filtrato anche in questo contesto, dovrai modificare il filtro.",
  "filter_modal.added.context_mismatch_title": "Contesto non corrispondente!",
  "filter_modal.added.expired_explanation": "La categoria di questo filtro è scaduta, dovrvai modificarne la data di scadenza per applicarlo.",
  "filter_modal.added.expired_title": "Filtro scaduto!",
  "filter_modal.added.review_and_configure": "Per revisionare e configurare ulteriormente la categoria di questo filtro, vai alle {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Impostazioni del filtro",
  "filter_modal.added.settings_link": "pagina delle impostazioni",
  "filter_modal.added.short_explanation": "Questo post è stato aggiunto alla seguente categoria del filtro: {title}.",
  "filter_modal.added.title": "Filtro aggiunto!",
  "filter_modal.select_filter.context_mismatch": "non si applica a questo contesto",
  "filter_modal.select_filter.expired": "scaduto",
  "filter_modal.select_filter.prompt_new": "Nuova categoria: {name}",
  "filter_modal.select_filter.search": "Cerca o crea",
  "filter_modal.select_filter.subtitle": "Usa una categoria esistente o creane una nuova",
  "filter_modal.select_filter.title": "Filtra questo post",
  "filter_modal.title.status": "Filtra un post",
  "filter_warning.matches_filter": "Corrisponde al filtro “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Da {count, plural, =0 {nessuno} one {una persona} other {# persone}} che potresti conoscere",
  "filtered_notifications_banner.title": "Notifiche filtrate",
  "firehose.all": "Tutto",
  "firehose.local": "Questo server",
  "firehose.remote": "Altri server",
  "follow_request.authorize": "Autorizza",
  "follow_request.reject": "Rifiuta",
  "follow_requests.unlocked_explanation": "Anche se il tuo profilo non è privato, lo staff di {domain} ha pensato che potresti voler revisionare manualmente le richieste di seguirti da questi profili.",
  "follow_suggestions.curated_suggestion": "Scelta personale",
  "follow_suggestions.dismiss": "Non visualizzare più",
  "follow_suggestions.featured_longer": "Selezionato personalmente dal team di {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popolare tra le persone che segui",
  "follow_suggestions.hints.featured": "Questo profilo è stato selezionato personalmente dal team di {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Questo profilo è popolare tra le persone che segui.",
  "follow_suggestions.hints.most_followed": "Questo profilo è uno dei più seguiti su {domain}.",
  "follow_suggestions.hints.most_interactions": "Recentemente, questo profilo ha ricevuto molta attenzione su {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Questo profilo è simile a quelli che hai iniziato a seguire più recentemente.",
  "follow_suggestions.personalized_suggestion": "Suggerimento personalizzato",
  "follow_suggestions.popular_suggestion": "Suggerimento frequente",
  "follow_suggestions.popular_suggestion_longer": "Popolare su {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Simile ai profili seguiti di recente",
  "follow_suggestions.view_all": "Vedi tutto",
  "follow_suggestions.who_to_follow": "Chi seguire",
  "followed_tags": "Hashtag seguiti",
  "followers.hide_other_followers": "Questo/a utente ha scelto di non rendere visibili gli altri suoi follower",
  "followers.title": "Follower di {name}",
  "following.hide_other_following": "Questo/a utente ha scelto di non rendere visibile il resto dei profili che segue",
  "following.title": "Seguiti da {name}",
  "footer.about": "Info",
  "footer.about_mastodon": "Riguardo Mastodon",
  "footer.about_server": "Riguardo {domain}",
  "footer.about_this_server": "Info",
  "footer.directory": "Elenco dei profili",
  "footer.get_app": "Scarica l'app",
  "footer.keyboard_shortcuts": "Scorciatoie da tastiera",
  "footer.privacy_policy": "Informativa sulla privacy",
  "footer.source_code": "Visualizza il codice sorgente",
  "footer.status": "Stato",
  "footer.terms_of_service": "Termini di servizio",
  "form_error.blank": "Il campo non può essere vuoto.",
  "form_field.optional": "(opzionale)",
  "getting_started.heading": "Per iniziare",
  "hashtag.admin_moderation": "Apri l'interfaccia di moderazione per #{name}",
  "hashtag.browse": "Sfoglia i post con #{hashtag}",
  "hashtag.browse_from_account": "Sfoglia i post da @{name} con #{hashtag}",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "senza {additional}",
  "hashtag.column_settings.select.no_options_message": "Nessun suggerimento trovato",
  "hashtag.column_settings.select.placeholder": "Inserisci gli hashtag…",
  "hashtag.column_settings.tag_mode.all": "Tutti questi",
  "hashtag.column_settings.tag_mode.any": "Uno o più di questi",
  "hashtag.column_settings.tag_mode.none": "Nessuno di questi",
  "hashtag.column_settings.tag_toggle": "Includi i tag aggiuntivi per questa colonna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} partecipante} other {{counter} partecipanti}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} post} other {{counter} post}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} post} other {{counter} post}} oggi",
  "hashtag.feature": "In evidenza sul profilo",
  "hashtag.follow": "Segui l'hashtag",
  "hashtag.mute": "Silenzia #{hashtag}",
  "hashtag.unfeature": "Non mostrare sul profilo",
  "hashtag.unfollow": "Smetti di seguire l'hashtag",
  "hashtags.and_other": "…e {count, plural, other {# in più}}",
  "hints.profiles.followers_may_be_missing": "I follower per questo profilo potrebbero essere mancanti.",
  "hints.profiles.follows_may_be_missing": "I profili seguiti per questo profilo potrebbero essere mancanti.",
  "hints.profiles.posts_may_be_missing": "Alcuni post da questo profilo potrebbero essere mancanti.",
  "hints.profiles.see_more_followers": "Vedi altri follower su {domain}",
  "hints.profiles.see_more_follows": "Vedi altri profili seguiti su {domain}",
  "hints.profiles.see_more_posts": "Vedi altri post su {domain}",
  "home.column_settings.show_quotes": "Mostra le citazioni",
  "home.column_settings.show_reblogs": "Mostra le condivisioni",
  "home.column_settings.show_replies": "Mostra le risposte",
  "home.hide_announcements": "Nascondi annunci",
  "home.pending_critical_update.body": "Ti preghiamo di aggiornare il tuo server di Mastodon, il prima possibile!",
  "home.pending_critical_update.link": "Visualizza aggiornamenti",
  "home.pending_critical_update.title": "Aggiornamento critico di sicurezza disponibile!",
  "home.show_announcements": "Mostra annunci",
  "ignore_notifications_modal.bots_title": "Ignorare le notifiche dai bot?",
  "ignore_notifications_modal.disclaimer": "Mastodon non può informare gli utenti che hai ignorato le loro notifiche. Ignorare le notifiche non impedirà l'invio dei messaggi stessi.",
  "ignore_notifications_modal.filter_instead": "Filtra invece",
  "ignore_notifications_modal.filter_to_act_users": "Potrai comunque accettare, rifiutare o segnalare gli utenti",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Il filtraggio aiuta a evitare potenziali confusioni",
  "ignore_notifications_modal.filter_to_review_separately": "Puoi rivedere le notifiche filtrate separatamente",
  "ignore_notifications_modal.ignore": "Ignora le notifiche",
  "ignore_notifications_modal.limited_accounts_title": "Ignorare le notifiche dagli account moderati?",
  "ignore_notifications_modal.new_accounts_title": "Ignorare le notifiche dai nuovi account?",
  "ignore_notifications_modal.not_followers_title": "Ignorare le notifiche delle persone che non ti seguono?",
  "ignore_notifications_modal.not_following_title": "Ignorare le notifiche delle persone che non segui?",
  "ignore_notifications_modal.private_mentions_title": "Ignorare le notifiche provenienti da menzioni private indesiderate?",
  "info_button.label": "Aiuto",
  "info_button.what_is_alt_text": "<h1>Cos'è il testo alternativo?</h1> <p>Il testo alternativo fornisce descrizioni delle immagini per le persone con disturbi della vista, connessioni a bassa larghezza di banda o per coloro che cercano un contesto aggiuntivo.</p> <p>È possibile migliorare l'accessibilità e la comprensione per tutti scrivendo un testo alt chiaro, conciso e obiettivo.</p> <ul> <li>Cattura elementi importanti</li> <li>Riassume il testo nelle immagini</li> <li>Usa la struttura delle frasi regolari</li> <li>Evita le informazioni ridondanti</li> <li>Concentrati sulle tendenze e i risultati chiave in immagini complesse (come diagrammi o mappe)</li> </ul>",
  "interaction_modal.action": "Per interagire con il post di {name}, devi accedere al tuo account su qualsiasi server Mastodon tu utilizzi.",
  "interaction_modal.action_follow": "Per seguire {name}, devi accedere al tuo account su qualunque server Mastodon tu utilizzi.",
  "interaction_modal.go": "Vai",
  "interaction_modal.no_account_yet": "Non hai ancora un account?",
  "interaction_modal.on_another_server": "Su un altro server",
  "interaction_modal.on_this_server": "Su questo server",
  "interaction_modal.title": "Accedi per continuare",
  "interaction_modal.username_prompt": "Es. {example}",
  "intervals.full.days": "{number, plural, one {# giorno} other {# giorni}}",
  "intervals.full.hours": "{number, plural, one {# ora} other {# ore}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minuti}}",
  "keyboard_shortcuts.back": "Torna indietro",
  "keyboard_shortcuts.blocked": "Apre l'elenco degli utenti bloccati",
  "keyboard_shortcuts.boost": "Condividi il post",
  "keyboard_shortcuts.column": "Focalizza alla colonna",
  "keyboard_shortcuts.compose": "Focalizza l'area di composizione testuale",
  "keyboard_shortcuts.description": "Descrizione",
  "keyboard_shortcuts.direct": "Aprire la colonna delle menzioni private",
  "keyboard_shortcuts.down": "Scorri in basso nell'elenco",
  "keyboard_shortcuts.enter": "Apre il post",
  "keyboard_shortcuts.explore": "Apri la timeline di tendenza",
  "keyboard_shortcuts.favourite": "Contrassegna il post come preferito",
  "keyboard_shortcuts.favourites": "Apre l'elenco dei preferiti",
  "keyboard_shortcuts.federated": "Apre la cronologia federata",
  "keyboard_shortcuts.heading": "Scorciatoie da tastiera",
  "keyboard_shortcuts.home": "Apre la cronologia domestica",
  "keyboard_shortcuts.hotkey": "Tasto di scelta rapida",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Spazio",
  "keyboard_shortcuts.keys.enter": "Invio",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Pagina giù",
  "keyboard_shortcuts.keys.page_up": "Pagina su",
  "keyboard_shortcuts.legend": "Mostra questa legenda",
  "keyboard_shortcuts.load_more": "Evidenzia il pulsante \"Carica altro\"",
  "keyboard_shortcuts.local": "Apre la cronologia locale",
  "keyboard_shortcuts.mention": "Menziona l'autore",
  "keyboard_shortcuts.muted": "Apre l'elenco degli utenti silenziati",
  "keyboard_shortcuts.my_profile": "Apre il tuo profilo",
  "keyboard_shortcuts.notifications": "Apre la colonna delle notifiche",
  "keyboard_shortcuts.open_media": "Apre i multimedia",
  "keyboard_shortcuts.pinned": "Apre l'elenco dei post fissati",
  "keyboard_shortcuts.profile": "Apre il profilo dell'autore",
  "keyboard_shortcuts.quote": "Cita post",
  "keyboard_shortcuts.reply": "Risponde al post",
  "keyboard_shortcuts.requests": "Apre l'elenco delle richieste di seguirti",
  "keyboard_shortcuts.search": "Focalizza sulla barra di ricerca",
  "keyboard_shortcuts.spoilers": "Mostra/Nasconde il campo CW",
  "keyboard_shortcuts.start": "Apre la colonna \"per iniziare\"",
  "keyboard_shortcuts.toggle_hidden": "Mostra/Nasconde il testo dietro CW",
  "keyboard_shortcuts.toggle_sensitivity": "Mostra/Nasconde media",
  "keyboard_shortcuts.toot": "Crea un nuovo post",
  "keyboard_shortcuts.top": "Sposta all'inizio della lista",
  "keyboard_shortcuts.translate": "Traduci un post",
  "keyboard_shortcuts.unfocus": "Rimuove il focus sull'area di composizione testuale/ricerca",
  "keyboard_shortcuts.up": "Scorre in su nell'elenco",
  "learn_more_link.got_it": "Ho capito",
  "learn_more_link.learn_more": "Scopri di più",
  "lightbox.close": "Chiudi",
  "lightbox.next": "Successivo",
  "lightbox.previous": "Precedente",
  "lightbox.zoom_in": "Ingrandisci alla dimensione attuale",
  "lightbox.zoom_out": "Ingrandisci per adattarsi",
  "limited_account_hint.action": "Mostra comunque il profilo",
  "limited_account_hint.title": "Questo profilo o server è stato nascosto dai moderatori di {domain}.",
  "link_preview.author": "Di {name}",
  "link_preview.more_from_author": "Altro da {name}",
  "link_preview.shares": "{count, plural, one {{counter} post} other {{counter} post}}",
  "lists.add_member": "Aggiungi",
  "lists.add_to_list": "Aggiungi alla lista",
  "lists.add_to_lists": "Aggiungi {name} alle liste",
  "lists.create": "Crea",
  "lists.create_a_list_to_organize": "Crea una nuova lista per organizzare il tuo feed Home",
  "lists.create_list": "Crea lista",
  "lists.delete": "Elimina elenco",
  "lists.done": "Fatto",
  "lists.edit": "Modifica elenco",
  "lists.exclusive": "Nascondi i membri in Home",
  "lists.exclusive_hint": "Se qualcuno è presente in questa lista, nascondilo dal tuo feed principale della Home per evitare di vedere i suoi post due volte.",
  "lists.find_users_to_add": "Trova utenti da aggiungere",
  "lists.list_members_count": "{count, plural, one {# membro} other {# membri}}",
  "lists.list_name": "Nome della lista",
  "lists.new_list_name": "Nuovo nome della lista",
  "lists.no_lists_yet": "Non ci sono ancora liste.",
  "lists.no_members_yet": "Non ci sono ancora membri.",
  "lists.no_results_found": "Nessun risultato trovato.",
  "lists.remove_member": "Rimuovi",
  "lists.replies_policy.followed": "Qualsiasi utente seguito",
  "lists.replies_policy.list": "Membri della lista",
  "lists.replies_policy.none": "Nessuno",
  "lists.save": "Salva",
  "lists.search": "Cerca",
  "lists.show_replies_to": "Includi le risposte dei membri della lista a",
  "load_pending": "{count, plural, one {# nuovo oggetto} other {# nuovi oggetti}}",
  "loading_indicator.label": "Caricamento…",
  "media_gallery.hide": "Nascondi",
  "moved_to_account_banner.text": "Il tuo profilo {disabledAccount} è correntemente disabilitato perché ti sei spostato a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Nascondi dalle notifiche",
  "mute_modal.hide_options": "Nascondi le opzioni",
  "mute_modal.indefinite": "Finché io non le riattivo",
  "mute_modal.show_options": "Mostre le opzioni",
  "mute_modal.they_can_mention_and_follow": "Può menzionarti e seguirti, ma tu non lo/a vedrai.",
  "mute_modal.they_wont_know": "Non sapranno di essere stati silenziati.",
  "mute_modal.title": "Silenziare l'utente?",
  "mute_modal.you_wont_see_mentions": "Non vedrai i post che li menzionano.",
  "mute_modal.you_wont_see_posts": "Potrà ancora vedere i tuoi post, ma tu non vedrai i suoi.",
  "navigation_bar.about": "Info",
  "navigation_bar.account_settings": "Password e sicurezza",
  "navigation_bar.administration": "Amministrazione",
  "navigation_bar.advanced_interface": "Apri nell'interfaccia web avanzata",
  "navigation_bar.automated_deletion": "Cancellazione automatica dei post",
  "navigation_bar.blocks": "Utenti bloccati",
  "navigation_bar.bookmarks": "Segnalibri",
  "navigation_bar.collections": "Collezioni",
  "navigation_bar.direct": "Menzioni private",
  "navigation_bar.domain_blocks": "Domini bloccati",
  "navigation_bar.favourites": "Apprezzamenti",
  "navigation_bar.filters": "Parole silenziate",
  "navigation_bar.follow_requests": "Richieste di seguirti",
  "navigation_bar.followed_tags": "Hashtag seguiti",
  "navigation_bar.follows_and_followers": "Seguiti e follower",
  "navigation_bar.import_export": "Importa ed esporta",
  "navigation_bar.lists": "Liste",
  "navigation_bar.live_feed_local": "Feed in diretta (locale)",
  "navigation_bar.live_feed_public": "Feed in diretta (pubblico)",
  "navigation_bar.logout": "Disconnettiti",
  "navigation_bar.main": "Menù principale",
  "navigation_bar.moderation": "Moderazione",
  "navigation_bar.more": "Altro",
  "navigation_bar.mutes": "Utenti silenziati",
  "navigation_bar.opened_in_classic_interface": "Post, account e altre pagine specifiche sono aperti per impostazione predefinita nella classica interfaccia web.",
  "navigation_bar.preferences": "Preferenze",
  "navigation_bar.privacy_and_reach": "Privacy e visibilità",
  "navigation_bar.search": "Cerca",
  "navigation_bar.search_trends": "Cerca / In tendenza",
  "navigation_panel.collapse_followed_tags": "Comprimi il menù degli hashtag seguiti",
  "navigation_panel.collapse_lists": "Chiudi il menu elenco",
  "navigation_panel.expand_followed_tags": "Espandi il menù degli hashtag seguiti",
  "navigation_panel.expand_lists": "Espandi il menu elenco",
  "not_signed_in_indicator.not_signed_in": "Devi accedere per consultare questa risorsa.",
  "notification.added_to_collection": "{name} ti ha aggiunto/a a una collezione",
  "notification.admin.report": "{name} ha segnalato {target}",
  "notification.admin.report_account": "{name} ha segnalato {count, plural, one {un post} other {# post}} da {target} per {category}",
  "notification.admin.report_account_other": "{name} ha segnalato {count, plural, one {un post} other {# post}} da {target}",
  "notification.admin.report_statuses": "{name} ha segnalato {target} per {category}",
  "notification.admin.report_statuses_other": "{name} ha segnalato {target}",
  "notification.admin.sign_up": "{name} si è iscritto",
  "notification.admin.sign_up.name_and_others": "Si sono iscritti: {name} e {count, plural, one {# altro utente} other {altri # utenti}}",
  "notification.annual_report.message": "Il tuo #Wrapstodon {year} ti aspetta! Scopri i momenti salienti e memorabili del tuo anno su Mastodon!",
  "notification.annual_report.view": "Visualizza #Wrapstodon",
  "notification.collection_update": "{name} ha modificato una collezione in cui sei presente",
  "notification.favourite": "{name} ha aggiunto il tuo post ai preferiti",
  "notification.favourite.name_and_others_with_link": "{name} e <a>{count, plural, one {# altro} other {altri #}}</a> hanno aggiunto il tuo post ai preferiti",
  "notification.favourite_pm": "{name} ha aggiunto ai preferiti la tua menzione privata",
  "notification.favourite_pm.name_and_others_with_link": "{name} e <a>{count, plural, one {# altro utente} other {# altri utenti}}</a> hanno aggiunto ai preferiti la tua menzione privata",
  "notification.follow": "{name} ha iniziato a seguirti",
  "notification.follow.name_and_others": "{name} e <a>{count, plural, one {# altro} other {altri #}}</a> hanno iniziato a seguirti",
  "notification.follow_request": "{name} ha richiesto di seguirti",
  "notification.follow_request.name_and_others": "{name} e {count, plural, one {# altro} other {altri #}} hanno richiesto di seguirti",
  "notification.label.mention": "Menziona",
  "notification.label.private_mention": "Menzione privata",
  "notification.label.private_reply": "Risposta in privato",
  "notification.label.quote": "{name} ha citato il tuo post",
  "notification.label.reply": "Rispondi",
  "notification.mention": "Menziona",
  "notification.mentioned_you": "{name} ti ha menzionato",
  "notification.moderation-warning.learn_more": "Scopri di più",
  "notification.moderation_warning": "Hai ricevuto un avviso di moderazione",
  "notification.moderation_warning.action_delete_statuses": "Alcuni dei tuoi post sono stati rimossi.",
  "notification.moderation_warning.action_disable": "Il tuo account è stato disattivato.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Alcuni dei tuoi post sono stati contrassegnati come sensibili.",
  "notification.moderation_warning.action_none": "Il tuo account ha ricevuto un avviso di moderazione.",
  "notification.moderation_warning.action_sensitive": "I tuoi post d'ora in poi saranno contrassegnati come sensibili.",
  "notification.moderation_warning.action_silence": "Il tuo account è stato limitato.",
  "notification.moderation_warning.action_suspend": "Il tuo account è stato sospeso.",
  "notification.own_poll": "Il tuo sondaggio è terminato",
  "notification.poll": "Un sondaggio in cui hai votato è terminato",
  "notification.quoted_update": "{name} ha modificato un post che hai citato",
  "notification.reblog": "{name} ha condiviso il tuo post",
  "notification.reblog.name_and_others_with_link": "{name} e <a>{count,  plural, one {# altro} other {altri #}}</a> hanno condiviso il tuo post",
  "notification.relationships_severance_event": "Connessioni perse con {name}",
  "notification.relationships_severance_event.account_suspension": "Un amministratore da {from} ha sospeso {target}, il che significa che non puoi più ricevere aggiornamenti da loro o interagire con loro.",
  "notification.relationships_severance_event.domain_block": "Un amministratore da {from} ha bloccato {target}, inclusi {followersCount} dei tuoi follower e {followingCount, plural, one {# account} other {# account}} che segui.",
  "notification.relationships_severance_event.learn_more": "Scopri di più",
  "notification.relationships_severance_event.user_domain_block": "Hai bloccato {target}, rimuovendo {followersCount} dei tuoi follower e {followingCount, plural, one {# account} other {# account}} che segui.",
  "notification.status": "{name} ha appena pubblicato un post",
  "notification.update": "{name} ha modificato un post",
  "notification_requests.accept": "Accetta",
  "notification_requests.accept_multiple": "{count, plural, one {Accetta # richiesta…} other {Accetta # richieste…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Accetta la richiesta} other {Accetta le richieste}}",
  "notification_requests.confirm_accept_multiple.message": "Stai per accettare {count, plural, one {una richiesta di notifica} other {# richieste di notifica}}. Si è sicuri di voler procedere?",
  "notification_requests.confirm_accept_multiple.title": "Accettare le richieste di notifica?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Ignora la richiesta} other {Ignora le richieste}}",
  "notification_requests.confirm_dismiss_multiple.message": "Stai per ignorare {count, plural, one {una richiesta di notifica} other {# richieste di notifiche}}. Non potrai più accedere facilmente ad {count, plural, one {essa} other {esse}}. Si è sicuri di voler procedere?",
  "notification_requests.confirm_dismiss_multiple.title": "Ignorare le richieste di notifica?",
  "notification_requests.dismiss": "Ignora",
  "notification_requests.dismiss_multiple": "{count, plural, one {Ignora # richiesta…} other {Ignora # richieste…}}",
  "notification_requests.edit_selection": "Modifica",
  "notification_requests.exit_selection": "Fatto",
  "notification_requests.explainer_for_limited_account": "Le notifiche provenienti da questo account sono state filtrate perché l'account è stato limitato da un moderatore.",
  "notification_requests.explainer_for_limited_remote_account": "Le notifiche provenienti da questo account sono state filtrate perché l'account o il suo server sono stati limitati da un moderatore.",
  "notification_requests.maximize": "Ingrandisci",
  "notification_requests.minimize_banner": "Minimizza il banner delle notifiche filtrate",
  "notification_requests.notifications_from": "Notifiche da {name}",
  "notification_requests.title": "Notifiche filtrate",
  "notification_requests.view": "Visualizza le notifiche",
  "notifications.clear": "Cancella le notifiche",
  "notifications.clear_confirmation": "Sei sicuro di voler cancellare permanentemente tutte le tue notifiche?",
  "notifications.clear_title": "Cancellare le notifiche?",
  "notifications.column_settings.admin.report": "Nuove segnalazioni:",
  "notifications.column_settings.admin.sign_up": "Nuove iscrizioni:",
  "notifications.column_settings.alert": "Notifiche desktop",
  "notifications.column_settings.collections": "Collezioni:",
  "notifications.column_settings.favourite": "Preferiti:",
  "notifications.column_settings.filter_bar.advanced": "Mostra tutte le categorie",
  "notifications.column_settings.filter_bar.category": "Barra del filtro veloce",
  "notifications.column_settings.follow": "Nuovi follower:",
  "notifications.column_settings.follow_request": "Nuove richieste di seguirti:",
  "notifications.column_settings.group": "Gruppo",
  "notifications.column_settings.mention": "Menzioni:",
  "notifications.column_settings.poll": "Risultati del sondaggio:",
  "notifications.column_settings.push": "Notifiche push",
  "notifications.column_settings.quote": "Citazioni:",
  "notifications.column_settings.reblog": "Post condivisi:",
  "notifications.column_settings.show": "Mostra nella colonna",
  "notifications.column_settings.sound": "Riproduci suono",
  "notifications.column_settings.status": "Nuovi post:",
  "notifications.column_settings.unread_notifications.category": "Notifiche non lette",
  "notifications.column_settings.unread_notifications.highlight": "Evidenzia le notifiche non lette",
  "notifications.column_settings.update": "Modifiche:",
  "notifications.filter.all": "Tutti",
  "notifications.filter.boosts": "Condivisioni",
  "notifications.filter.collections": "Collezioni",
  "notifications.filter.favourites": "Preferiti",
  "notifications.filter.follows": "Seguaci",
  "notifications.filter.mentions": "Menzioni",
  "notifications.filter.polls": "Risultati del sondaggio",
  "notifications.filter.statuses": "Aggiornamenti dalle persone che segui",
  "notifications.grant_permission": "Concedi autorizzazione.",
  "notifications.group": "{count} notifiche",
  "notifications.mark_as_read": "Segna tutte le notifiche come lette",
  "notifications.permission_denied": "Notifiche desktop non disponibili a causa della precedentemente negata richiesta di autorizzazioni del browser",
  "notifications.permission_denied_alert": "Impossibile abilitare le notifiche desktop, poiché l'autorizzazione del browser è stata precedentemente negata",
  "notifications.permission_required": "Notifiche destkop non disponibili poiché l'autorizzazione richiesta non è stata concessa.",
  "notifications.policy.accept": "Accetta",
  "notifications.policy.accept_hint": "Mostra nelle notifiche",
  "notifications.policy.drop": "Ignora",
  "notifications.policy.drop_hint": "Scarta definitivamente, per non essere mai più visto",
  "notifications.policy.filter": "Filtrare",
  "notifications.policy.filter_bots_hint": "Account contrassegnati come automatizzati",
  "notifications.policy.filter_bots_title": "Bot",
  "notifications.policy.filter_hint": "Invia alla casella in arrivo delle notifiche filtrate",
  "notifications.policy.filter_limited_accounts_hint": "Limitato dai moderatori del server",
  "notifications.policy.filter_limited_accounts_title": "Account moderati",
  "notifications.policy.filter_new_accounts.hint": "Creato {days, plural, one {un giorno} other {# giorni}} fa",
  "notifications.policy.filter_new_accounts_title": "Nuovi account",
  "notifications.policy.filter_not_followers_hint": "Incluse le persone che ti seguono da meno di {days, plural, one {un giorno} other {# giorni}}",
  "notifications.policy.filter_not_followers_title": "Persone che non ti seguono",
  "notifications.policy.filter_not_following_hint": "Fino a quando non le approvi manualmente",
  "notifications.policy.filter_not_following_title": "Persone che non segui",
  "notifications.policy.filter_private_mentions_hint": "Filtrate, a meno che non sia in risposta alla tua menzione o se segui il mittente",
  "notifications.policy.filter_private_mentions_title": "Menzioni private indesiderate",
  "notifications.policy.title": "Gestisci le notifiche da…",
  "notifications_permission_banner.enable": "Abilita le notifiche desktop",
  "notifications_permission_banner.how_to_control": "Per ricevere le notifiche quando Mastodon non è aperto, abilita le notifiche desktop. Puoi controllare precisamente quali tipi di interazioni generano le notifiche destkop, tramite il pulsante {icon} sopra, una volta abilitate.",
  "notifications_permission_banner.title": "Non perderti mai nulla",
  "onboarding.follows.back": "Indietro",
  "onboarding.follows.empty": "Sfortunatamente, nessun risultato può essere mostrato in questo momento. Puoi provare a utilizzare la ricerca o sfogliare la pagina di esplorazione per trovare persone da seguire, oppure riprova più tardi.",
  "onboarding.follows.next": "Successivo: imposta il tuo profilo",
  "onboarding.follows.search": "Cerca",
  "onboarding.follows.title": "Segui le persone per iniziare",
  "onboarding.profile.discoverable": "Rendi il mio profilo individuabile",
  "onboarding.profile.discoverable_hint": "Quando attivi la rilevabilità su Mastodon, i tuoi post potrebbero apparire nei risultati di ricerca e nelle tendenze e il tuo profilo potrebbe essere suggerito a persone con interessi simili ai tuoi.",
  "onboarding.profile.display_name": "Nome mostrato",
  "onboarding.profile.display_name_hint": "Il tuo nome completo o il tuo nome divertente…",
  "onboarding.profile.finish": "Fine",
  "onboarding.profile.note": "Biografia",
  "onboarding.profile.note_hint": "Puoi @menzionare altre persone o #hashtags…",
  "onboarding.profile.title": "Configurazione del profilo",
  "onboarding.profile.upload_avatar": "Carica l'immagine del profilo",
  "onboarding.profile.upload_header": "Carica l'intestazione del profilo",
  "password_confirmation.exceeds_maxlength": "La conferma della password supera la lunghezza massima della password",
  "password_confirmation.mismatching": "Le password non corrispondono",
  "picture_in_picture.restore": "Ripristina il riquadro",
  "poll.closed": "Chiuso",
  "poll.refresh": "Aggiorna",
  "poll.reveal": "Vedi risultati",
  "poll.total_people": "{count, plural, one {# persona} other {# persone}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# voti}}",
  "poll.vote": "Vota",
  "poll.voted": "Hai votato per questa risposta",
  "poll.votes": "{votes, plural, one {# voto} other {# voti}}",
  "poll_button.add_poll": "Aggiungi un sondaggio",
  "poll_button.remove_poll": "Rimuovi il sondaggio",
  "privacy.change": "Modifica privacy del post",
  "privacy.direct.long": "Tutti quelli menzionati nel post",
  "privacy.direct.short": "Menzione privata",
  "privacy.private.long": "Solo i tuoi follower",
  "privacy.private.short": "Follower",
  "privacy.public.long": "Chiunque dentro e fuori Mastodon",
  "privacy.public.short": "Pubblico",
  "privacy.quote.anyone": "{visibility}, citazioni autorizzate",
  "privacy.quote.disabled": "{visibility}, citazioni disabilitate",
  "privacy.quote.limited": "{visibility}, citazioni limitate",
  "privacy.unlisted.additional": "Si comporta esattamente come pubblico, tranne per il fatto che il post non verrà visualizzato nei feed live o negli hashtag, nell'esplorazione o nella ricerca Mastodon, anche se hai attivato l'attivazione a livello di account.",
  "privacy.unlisted.long": "Nascosto dai risultati di ricerca di Mastodon, dalle tendenze e dalle timeline pubbliche",
  "privacy.unlisted.short": "Pubblico silenzioso",
  "privacy_policy.last_updated": "Ultimo aggiornamento {date}",
  "privacy_policy.title": "Informativa sulla privacy",
  "quote_error.edit": "Le citazioni non possono essere aggiunte quando si modifica un post.",
  "quote_error.poll": "Nei sondaggi non sono consentite le citazioni.",
  "quote_error.private_mentions": "Le citazioni non sono consentite con le menzioni dirette.",
  "quote_error.quote": "È consentita una sola citazione alla volta.",
  "quote_error.unauthorized": "Non sei autorizzato a citare questo post.",
  "quote_error.upload": "Le citazioni non sono consentite con gli allegati multimediali.",
  "recommended": "Consigliato",
  "refresh": "Ricarica",
  "regeneration_indicator.please_stand_by": "Si prega di rimanere in attesa.",
  "regeneration_indicator.preparing_your_home_feed": "Preparazione della tua home feed in corso…",
  "relative_time.days": "{number}g",
  "relative_time.full.days": "{number, plural, one {# giorno} other {# giorni}} fa",
  "relative_time.full.hours": "{number, plural, one {# ora} other {# ore}} fa",
  "relative_time.full.just_now": "proprio ora",
  "relative_time.full.minutes": "{number, plural, one {# minuto} other {# minuti}} fa",
  "relative_time.full.seconds": "{number, plural, one {# secondo} other {# secondi}} fa",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "ora",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "oggi",
  "remove_quote_hint.button_label": "Ho capito",
  "remove_quote_hint.message": "Puoi farlo dal menu delle opzioni {icon}.",
  "remove_quote_hint.title": "Vuoi rimuovere il tuo post citato?",
  "reply_indicator.attachments": "{count, plural, one {# allegato} other {# allegati}}",
  "reply_indicator.cancel": "Annulla",
  "reply_indicator.poll": "Sondaggio",
  "report.block": "Blocca",
  "report.block_explanation": "Non visualizzerai i suoi post. Non potrà vedere i tuoi post o seguirti. Potrà sapere di esser stato bloccato.",
  "report.categories.legal": "Informazioni legali",
  "report.categories.other": "Altro",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Il contenuto viola una o più regole del server",
  "report.category.subtitle": "Scegli la corrispondenza migliore",
  "report.category.title_account": "Dicci cosa sta succedendo con questo profilo",
  "report.category.title_collection": "Dicci cosa sta succedendo con questa collezione",
  "report.category.title_status": "Dicci cosa sta succedendo con questo post",
  "report.close": "Fatto",
  "report.comment.title": "C'è altro che pensi che dovremmo sapere?",
  "report.forward": "Inoltra a {target}",
  "report.forward_hint": "Il profilo proviene da un altro server. Inviare anche lì una copia anonima del rapporto?",
  "report.mute": "Silenzia",
  "report.mute_explanation": "Non visualizzerai i suoi post. Potrà comunque seguirti e visualizzare i tuoi post e non saprà di esser stato/a silenziato/a.",
  "report.next": "Successivo",
  "report.placeholder": "Commenti aggiuntivi",
  "report.reasons.dislike": "Non mi piace",
  "report.reasons.dislike_description": "Non è qualcosa che desideri vedere",
  "report.reasons.legal": "È illegale",
  "report.reasons.legal_description": "Ritieni che violi la legge del tuo paese o di quello del server",
  "report.reasons.other": "È qualcos'altro",
  "report.reasons.other_description": "Il problema non rientra in altre categorie",
  "report.reasons.spam": "È spam",
  "report.reasons.spam_description": "Link malevoli, false interazioni o risposte ripetitive",
  "report.reasons.violation": "Viola le regole del server",
  "report.reasons.violation_description": "Sei consapevole che viola regole specifiche",
  "report.rules.subtitle": "Seleziona tutte le risposte pertinenti",
  "report.rules.title": "Quali regole sono violate?",
  "report.statuses.subtitle": "Seleziona tutte le risposte pertinenti",
  "report.statuses.title": "Ci sono dei post a sostegno di questa segnalazione?",
  "report.submission_error": "Non è stato possibile inviare la segnalazione",
  "report.submission_error_details": "Si prega di controllare la tua connessione di rete e riprovare più tardi.",
  "report.submit": "Invia",
  "report.target": "Segnalando {target}",
  "report.thanks.take_action": "Ecco le tue opzioni per controllare cosa vedi su Mastodon:",
  "report.thanks.take_action_actionable": "Mentre revisioniamo questa segnalazione, puoi agire contro @{name}:",
  "report.thanks.title": "Non desideri vederlo?",
  "report.thanks.title_actionable": "Grazie per la segnalazione, ce ne occuperemo.",
  "report.unfollow": "Smetti di seguire @{name}",
  "report.unfollow_explanation": "Segui questo profilo. Per non visualizzare più i suoi post nel feed della tua home, smetti di seguirlo.",
  "report_notification.attached_statuses": "{count, plural, one {{count} post allegato} other {{count} post allegati}}",
  "report_notification.categories.legal": "Legale",
  "report_notification.categories.legal_sentence": "contenuti illegali",
  "report_notification.categories.other": "Altro",
  "report_notification.categories.other_sentence": "altri",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Violazione delle regole",
  "report_notification.categories.violation_sentence": "violazione delle regole",
  "report_notification.open": "Apri segnalazione",
  "search.clear": "Cancella ricerca",
  "search.no_recent_searches": "Nessuna ricerca recente",
  "search.placeholder": "Cerca",
  "search.quick_action.account_search": "Profili corrispondenti a {x}",
  "search.quick_action.go_to_account": "Vai al profilo {x}",
  "search.quick_action.go_to_hashtag": "Vai all'hashtag {x}",
  "search.quick_action.open_url": "Apri URL in Mastodon",
  "search.quick_action.status_search": "Post corrispondenti a {x}",
  "search.search_or_paste": "Cerca o incolla URL",
  "search_popout.full_text_search_disabled_message": "Non disponibile in {domain}.",
  "search_popout.full_text_search_logged_out_message": "Disponibili solo dopo aver effettuato l'accesso.",
  "search_popout.language_code": "Codice ISO lingua",
  "search_popout.options": "Opzioni di ricerca",
  "search_popout.quick_actions": "Azioni rapide",
  "search_popout.recent": "Ricerche recenti",
  "search_popout.specific_date": "data specifica",
  "search_popout.user": "utente",
  "search_results.accounts": "Profili",
  "search_results.all": "Tutto",
  "search_results.collections": "Collezioni",
  "search_results.hashtags": "Hashtag",
  "search_results.no_results": "Nessun risultato.",
  "search_results.no_search_yet": "Prova a cercare post, profili o hashtag.",
  "search_results.see_all": "Mostra tutto",
  "search_results.statuses": "Post",
  "search_results.title": "Cerca \"{q}\"",
  "server_banner.about_active_users": "Persone che hanno utilizzato questo server negli ultimi 30 giorni (Utenti Attivi Mensilmente)",
  "server_banner.active_users": "utenti attivi",
  "server_banner.administered_by": "Amministrato da:",
  "server_banner.is_one_of_many": "{domain} è uno dei tanti server Mastodon indipendenti che puoi usare per partecipare al fediverso.",
  "server_banner.more_about_this_server": "Maggiori informazioni su questo server",
  "server_banner.server_stats": "Statistiche del server:",
  "sign_in_banner.create_account": "Crea un profilo",
  "sign_in_banner.follow_anyone": "Segui chiunque nel fediverso e vedi tutto in ordine cronologico. Nessun algoritmo, annunci o clickbait in vista.",
  "sign_in_banner.mastodon_is": "Mastodon è il modo migliore per tenere il passo con quello che sta accadendo.",
  "sign_in_banner.sign_in": "Accedi",
  "sign_in_banner.sso_redirect": "Accedi o Registrati",
  "skip_links.hotkey": "<span>Scorciatoia</span> {hotkey}",
  "skip_links.skip_to_content": "Salta al contenuto principale",
  "skip_links.skip_to_navigation": "Salta alla navigazione principale",
  "status.admin_account": "Apri interfaccia di moderazione per @{name}",
  "status.admin_domain": "Apri l'interfaccia di moderazione per {domain}",
  "status.admin_status": "Apri questo post nell'interfaccia di moderazione",
  "status.all_disabled": "Condivisioni e citazioni sono disabilitate",
  "status.block": "Blocca @{name}",
  "status.bookmark": "Aggiungi segnalibro",
  "status.cancel_reblog_private": "Annulla la condivisione",
  "status.cannot_edit": "Non sei autorizzato/a a modificare questo post",
  "status.cannot_quote": "Non ti è consentito citare questo post",
  "status.cannot_reblog": "Questo post non può essere condiviso",
  "status.contains_quote": "Contiene una citazione",
  "status.context.loading": "Caricamento di altre risposte",
  "status.context.loading_error": "Impossibile caricare nuove risposte",
  "status.context.loading_success": "Nuove risposte caricate",
  "status.context.more_replies_found": "Altre risposte trovate",
  "status.context.retry": "Riprova",
  "status.context.show": "Mostra",
  "status.continued_thread": "Discussione continua",
  "status.copy": "Copia il collegamento al post",
  "status.delete": "Elimina",
  "status.delete.success": "Post eliminato",
  "status.detailed_status": "Vista conversazione dettagliata",
  "status.direct": "Menziona privatamente @{name}",
  "status.direct_indicator": "Menzione privata",
  "status.edit": "Modifica",
  "status.edited": "Ultima modifica {date}",
  "status.edited_x_times": "Modificato {count, plural, one {{count} volta} other {{count} volte}}",
  "status.embed": "Ottieni codice incorporato",
  "status.favourite": "Aggiungi ai preferiti",
  "status.favourites_count": "{count, plural, one {{counter} apprezzamento} other {{counter} apprezzamenti}}",
  "status.filter": "Filtra questo post",
  "status.history.created": "Creato da {name} il {date}",
  "status.history.edited": "Modificato da {name} il {date}",
  "status.load_more": "Carica altro",
  "status.media.open": "Clicca per aprire",
  "status.media.show": "Clicca per mostrare",
  "status.media_hidden": "Media nascosto",
  "status.mention": "Menziona @{name}",
  "status.more": "Altro",
  "status.mute": "Silenzia @{name}",
  "status.mute_conversation": "Silenzia conversazione",
  "status.not_quoted": "Non sei citato/a in questo post",
  "status.open": "Espandi questo post",
  "status.pin": "Fissa in cima sul profilo",
  "status.public_only": "Questo post è privato",
  "status.quote": "Cita",
  "status.quote.cancel": "Annulla la citazione",
  "status.quote_error.blocked_account_hint.title": "Questo post è nascosto perché hai bloccato @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Questo post è nascosto perché hai bloccato @{domain}.",
  "status.quote_error.filtered": "Nascosto a causa di uno dei tuoi filtri",
  "status.quote_error.limited_account_hint.action": "Mostra comunque",
  "status.quote_error.limited_account_hint.title": "Questo profilo è stato nascosto dai moderatori di {domain}.",
  "status.quote_error.muted_account_hint.title": "Questo post è nascosto perché hai silenziato @{name}.",
  "status.quote_error.not_available": "Post non disponibile",
  "status.quote_error.pending_approval": "Post in attesa",
  "status.quote_error.pending_approval_popout.body": "Su Mastodon, puoi controllare se qualcuno può citarti. Questo post è in attesa dell'approvazione dell'autore originale.",
  "status.quote_error.revoked": "Post rimosso dall'autore",
  "status.quote_followers_only": "Solo i follower possono citare questo post",
  "status.quote_manual_review": "L'autore esaminerà manualmente",
  "status.quote_noun": "Citazione",
  "status.quote_policy_change": "Cambia chi può citare",
  "status.quote_post_author": "Citato un post di @{name}",
  "status.quote_private": "I post privati non possono essere citati",
  "status.quotes.empty": "Nessuno ha ancora citato questo post. Quando qualcuno lo farà, verrà visualizzato qui.",
  "status.quotes.local_other_disclaimer": "Le citazioni rifiutate dall'autore non verranno mostrate.",
  "status.quotes.remote_other_disclaimer": "Solo le citazioni provenienti da {domain} saranno mostrate qui. Le citazioni rifiutate dall'autore non saranno mostrate.",
  "status.quotes_count": "{count, plural, one {{counter} citazione} other {{counter} citazioni}}",
  "status.read_more": "Leggi di più",
  "status.reblog": "Condividi",
  "status.reblog_or_quote": "Condividi o cita",
  "status.reblog_private": "Condividi di nuovo con i tuoi follower",
  "status.reblogged_by": "{name} ha condiviso",
  "status.reblogs.empty": "Nessuno ha ancora condiviso questo post. Quando qualcuno lo farà, comparirà qui.",
  "status.reblogs_count": "{count, plural, one {{counter} condivisione} other {{counter} condivisioni}}",
  "status.redraft": "Elimina e riscrivi",
  "status.remove_bookmark": "Rimuovi segnalibro",
  "status.remove_favourite": "Rimuovi dai preferiti",
  "status.remove_quote": "Rimuovi",
  "status.replied_in_thread": "Ha risposto nella discussione",
  "status.replied_to": "Risposta a {name}",
  "status.reply": "Rispondi",
  "status.replyAll": "Rispondi alla conversazione",
  "status.report": "Segnala @{name}",
  "status.request_quote": "Richiesta di citazione",
  "status.revoke_quote": "Rimuovi il mio post da quello di @{name}",
  "status.sensitive_warning": "Contenuto sensibile",
  "status.share": "Condividi",
  "status.show_less_all": "Mostra meno per tutti",
  "status.show_more_all": "Mostra di più per tutti",
  "status.show_original": "Mostra originale",
  "status.title.with_attachments": "{user} ha pubblicato {attachmentCount, plural, one {un allegato} other {{attachmentCount} allegati}}",
  "status.translate": "Traduci",
  "status.translated_from_with": "Tradotto da {lang} utilizzando {provider}",
  "status.uncached_media_warning": "Anteprima non disponibile",
  "status.unmute_conversation": "Annulla silenziamento conversazione",
  "status.unpin": "Non fissare sul profilo",
  "subscribed_languages.lead": "Solo i post nelle lingue selezionate appariranno sulla tua home e nelle cronologie dopo la modifica. Non selezionare nulla per ricevere i post in tutte le lingue.",
  "subscribed_languages.save": "Salva le modifiche",
  "subscribed_languages.target": "Cambia le lingue dei post da ricevere per {target}",
  "tabs_bar.home": "Home",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Notifiche",
  "tabs_bar.publish": "Nuovo post",
  "tabs_bar.quick_links": "Collegamenti rapidi",
  "tabs_bar.search": "Cerca",
  "tag.remove": "Rimuovi",
  "terms_of_service.effective_as_of": "In vigore a partire dal giorno {date}",
  "terms_of_service.title": "Termini di Servizio",
  "terms_of_service.upcoming_changes_on": "Prossime modifiche nel giorno {date}",
  "time_remaining.days": "{number, plural, one {# giorno rimanente} other {# giorni rimanenti}}",
  "time_remaining.hours": "{number, plural, one {# ora rimanente} other {# ore rimanenti}}",
  "time_remaining.minutes": "{number, plural, one {# minuto rimanente} other {# minuti rimanenti}}",
  "time_remaining.moments": "Restano pochi istanti",
  "time_remaining.seconds": "{number, plural, one {# secondo rimanente} other {# secondi rimanenti}}",
  "trends.counter_by_accounts": "{count, plural, one {{count} persona} other {{count} persone}} {days, plural, one {nell'ultimo giorno} other {negli ultimi {days} giorni}}",
  "trends.trending_now": "Ora in tendenza",
  "ui.beforeunload": "La tua bozza andrà persa, se abbandoni Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Trascina e rilascia per caricare",
  "upload_button.label": "Aggiungi un file immagine, video o audio",
  "upload_error.limit": "Limite di caricamento dei file superato.",
  "upload_error.poll": "Caricamento del file non consentito con i sondaggi.",
  "upload_error.quote": "Caricamento file non consentito con le citazioni.",
  "upload_form.drag_and_drop.instructions": "Per selezionare un allegato multimediale, premi Spazio o Invio. Mentre trascini, usa i tasti con le frecce per spostare l'allegato multimediale in una qualsiasi direzione. Premi di nuovo Spazio o Invio per rilasciare l'allegato multimediale nella sua nuova posizione, oppure premi Esc per annullare.",
  "upload_form.drag_and_drop.on_drag_cancel": "Il trascinamento è stato annullato. L'allegato multimediale {item} è stato eliminato.",
  "upload_form.drag_and_drop.on_drag_end": "L'allegato multimediale {item} è stato eliminato.",
  "upload_form.drag_and_drop.on_drag_over": "L'allegato multimediale {item} è stato spostato.",
  "upload_form.drag_and_drop.on_drag_start": "L'allegato multimediale {item} è stato ricevuto.",
  "upload_form.edit": "Modifica",
  "upload_progress.label": "Caricamento...",
  "upload_progress.processing": "Elaborazione…",
  "username.taken": "Quel nome utente è già in uso. Prova con un altro",
  "video.close": "Chiudi il video",
  "video.download": "Scarica file",
  "video.exit_fullscreen": "Esci dallo schermo intero",
  "video.expand": "Espandi il video",
  "video.fullscreen": "Schermo intero",
  "video.hide": "Nascondi il video",
  "video.mute": "Muta",
  "video.pause": "Pausa",
  "video.play": "Riproduci",
  "video.skip_backward": "Vai indietro",
  "video.skip_forward": "Vai avanti",
  "video.unmute": "Muta",
  "video.volume_down": "Abbassa volume",
  "video.volume_up": "Alza volume",
  "visibility_modal.button_title": "Imposta la visibilità",
  "visibility_modal.direct_quote_warning.text": "Se si salvano le impostazioni correnti, la citazione incorporata verrà convertita in un collegamento.",
  "visibility_modal.direct_quote_warning.title": "Le citazioni non possono essere incorporate in menzioni private",
  "visibility_modal.header": "Visibilità e interazione",
  "visibility_modal.helper.direct_quoting": "Le menzioni private scritte su Mastodon non possono essere citate da altri.",
  "visibility_modal.helper.privacy_editing": "La visibilità non può essere modificata dopo la pubblicazione di un post.",
  "visibility_modal.helper.privacy_private_self_quote": "Le autocitazioni di post privati ​​non possono essere rese pubbliche.",
  "visibility_modal.helper.private_quoting": "I post scritti e riservati ai follower su Mastodon non possono essere citati da altri.",
  "visibility_modal.helper.unlisted_quoting": "Quando le persone ti citano, il loro post verrà nascosto anche dalle timeline di tendenza.",
  "visibility_modal.instructions": "Controlla chi può interagire con questo post. Puoi anche applicare le impostazioni a tutti i post futuri andando su <link>Preferenze > Impostazioni predefinite per i post</link>.",
  "visibility_modal.privacy_label": "Visibilità",
  "visibility_modal.quote_followers": "Solo i follower",
  "visibility_modal.quote_label": "Chi può citare",
  "visibility_modal.quote_nobody": "Solo io",
  "visibility_modal.quote_public": "Chiunque",
  "visibility_modal.save": "Salva"
}
